/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import Topbar from "../../../components/Topbar";
import RecModal from "../../../components/Modal/RecModal";
import ApModal from "../../../components/Modal/ApModal";
import ItemModal from "../../../components/Modal/ItemModal";
import WtaxModal from "../../../components/Modal/WtaxModal";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";
import CreditorQuickCreateModal from "../../../components/Modal/CreditorQuickCreateModal";

// Model
import { payMasterModel } from "../../../../model/Purchase/PayMasterModel";
import { payDetailModel } from "../../../../model/Purchase/PayDetailModel";

// Utils
import {
  getData,
  getDataWithComp,
  getByPayId,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxPayNo,
  updateStatusByNo,
  deleteData,
  updateQty,
  insertData,
  updateData,
  getViewPoH,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
  formatDate,
  formatThaiDayMonthShortYear,
} from "../../../../utils/DateUtils";
import PoModal from "../../../components/Modal/PoModal";

function Form({
  callInitialize,
  mode,
  setMode,
  name,
  maxPayNo,
  getReport,
  listUrl = "/payment-voucher",
  isApprovalPage = false,
  onApprove,
  onReject,
  pendingStatus = 1,
  approvalBusy = false,
}) {
  const isReadOnly = isApprovalPage;
  const showApprovalButtons = isApprovalPage;
  const [formMasterList, setFormMasterList] = useState([payMasterModel()]);
  const [formDetailList, setFormDetailList] = useState([]);
  const [recDataList, setRecDataList] = useState([]);
  const [poDataList, setPoDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [deposDataList, setDeposDataList] = useState([]);
  const [showCreditorModal, setShowCreditorModal] = useState(false);
  const [docRef, setDocRef] = useState("");
  const [Ref_PAY_ID, setRef_PAY_ID] = useState();
  const fetchApList = async () => {
    const apList = await getDataWithComp("Tb_Set_AP", "ORDER BY AP_Code ASC");
    if (apList && apList.length > 0) {
      setApDataList(apList);
    } else {
      setApDataList([]);
    }
    return apList;
  };
  const handleCreditorSuccess = async (insertedAp) => {
    const apList = await fetchApList();
    setShowCreditorModal(false);
    if (insertedAp) {
      const found = apList
        ? apList.find(
          (a) => String(a.AP_Id) === String(insertedAp.AP_Id) || a.AP_Code === insertedAp.AP_Code
        )
        : null;
      if (found) onRowSelectAp(found);
    }
  };

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);

  const [FinalTotal, setFinalTotal] = useState(0);
  const [disTotal, setDisTotal] = useState(0);
  const [inputValuedisTotal, setInputValuedisTotal] = useState("0.00");

  const [outstandingBalance, setOutstandingBalance] = useState(0);

  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);
  const [totalWT, setTotalWT] = useState(0);
  const [inputValueTotalWT, setInputValueTotalWT] = useState("0.00");

  const [selectedOption, setSelectedOption] = useState(1);
  const currentDate = moment().format("YYYY/MM/DD");
  const [taxData, setTaxData] = useState([
    {
      id: 1,
      type: 5,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
    {
      id: 2,
      type: 6,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
  ]);

  const [taxtotalAmount, setTaxtotalAmount] = useState(0);

  const resolveRecIdFromDetail = (detail) => {
    if (!detail) return null;
    const rawRecId =
      detail.recId !== undefined && detail.recId !== null && detail.recId !== ""
        ? detail.recId
        : detail.rec_id;
    if (rawRecId !== undefined && rawRecId !== null && rawRecId !== "") {
      const parsed = parseCurrency(rawRecId);
      if (typeof parsed === "number" && !Number.isNaN(parsed)) {
        return parsed;
      }
      return rawRecId;
    }

    if (detail.recNo) {
      const match = recDataList.find((rec) => rec?.Rec_No === detail.recNo);
      if (match && match.Rec_Id !== undefined && match.Rec_Id !== null) {
        const parsed = parseCurrency(match.Rec_Id);
        if (typeof parsed === "number" && !Number.isNaN(parsed)) {
          return parsed;
        }
        return match.Rec_Id;
      }
    }

    return null;
  };

  // การใช้ Tab เพื่อเปลี่ยน Form
  const [activeTab, setActiveTab] = useState("summary");

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");

  // ใช้สำหรับการ Rendered Form ต่างๆ
  const [docRefType, setDocRefType] = useState("1");

  // ใช้สำหรับการทำเรื่องจ่ายเป็นงวด
  const [paymentStatus, setPaymentStatus] = useState("oneTime"); // สถานะการจ่าย (จ่ายครั้งเดียว หรือ จ่ายเป็นงวด)
  const [installmentCount, setInstallmentCount] = useState(1); // จำนวนงวด

  // ใช้สำหรับเก็บสถานะที่มาจากการทำใบจ่ายเพิ่มเติม
  const [isPayContinue, setIsPayContinue] = useState(false);

  const [base64Image, setBase64Image] = useState("");
  const [urlPic, setUrlPic] = useState("");

  // สำหรับจ่ายล่วงหน้า
  const [payBefore, setPayBefore] = useState(0);
  const [isPayBefore, setIsPayBefore] = useState(false);

  // ช่องทางการชำระเงิน
  const [paymentType, setPaymentType] = useState({
    cash: false,
    transfer: false,
    cheque: false,
  });
  const [paymentAmount, setPaymentAmount] = useState({
    cash: "0.00",
    transfer: "0.00",
    cheque: "0.00",
  });
  const [payDatetime, setPayDatetime] = useState(moment().format("YYYY-MM-DD"));
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("ธนาคารกสิกรไทย");
  const [chequeDate, setChequeDate] = useState("");
  const [bankInputMode, setBankInputMode] = useState("select");
  const [bankMasterId, setBankMasterId] = useState("");
  const [bankId, setBankId] = useState("");
  const [payToAccNo, setPayToAccNo] = useState("");
  const [payToAccName, setPayToAccName] = useState("");
  const [payToBranch, setPayToBranch] = useState("");
  const [masterBankDataList, setMasterBankDataList] = useState([]);
  const [bankDataList, setBankDataList] = useState([]);

  const truncateTo2Decimals = (num) => parseCurrency(num * 100) / 100;

  function roundTo2With3rdDigitRule(value) {
    const thirdDigit = parseCurrency(value * 1000) % 10;
    let rounded = parseCurrency(value * 100) / 100;
    if (thirdDigit >= 5) {
      rounded += 0.01;
    }
    return Number(rounded.toFixed(2));
  }

  const masterRecord = formMasterList[0] || {};
  const pendingStatusNumber = Number(pendingStatus) || 1;
  const isPendingApproval = Number(masterRecord.payStatus) === pendingStatusNumber;
  const canEditPaymentChannel = !isReadOnly && Number(masterRecord?.payStatus ?? 1) === 1;
  const isPaymentStatusDisabled = mode === "U" || docRefType === "4";

  const resetPaymentChannels = () => {
    setPaymentType({ cash: false, transfer: false, cheque: false });
    setPaymentAmount({ cash: "0.00", transfer: "0.00", cheque: "0.00" });
    setPayDatetime(moment().format("YYYY-MM-DD"));
    setChequeNo("");
    setChequeName("");
    setChequeBranch("ธนาคารกสิกรไทย");
    setChequeDate("");
    setBankInputMode("select");
    setBankMasterId("");
    setBankId("");
    setPayToAccNo("");
    setPayToAccName("");
    setPayToBranch("");
  };

  const formatAccountNo = (value) => {
    if (!value) return "";
    const digits = String(value).replace(/\D/g, "").slice(0, 10);
    const p1 = digits.slice(0, 3);
    const p2 = digits.slice(3, 6);
    const p3 = digits.slice(6, 10);
    return [p1, p2, p3].filter(Boolean).join("-");
  };

  const handleAccNoChange = (raw) => {
    const formatted = formatAccountNo(raw);
    setPayToAccNo(formatted);
  };

  const handleAccNoBlur = () => {
    const digits = String(payToAccNo).replace(/\D/g, "");
    if (payToAccNo && digits.length !== 10) {
      try {
        getAlert("WARNING", "รูปแบบเลขที่บัญชีต้องเป็น xxx-xxx-xxxx");
      } catch (e) {
        console.warn("Invalid account format");
      }
    }
  };

  const handlePaymentAmountChange = (method, rawValue) => {
    const sanitized = rawValue.replace(/[^0-9.]/g, "");
    setPaymentAmount((prev) => ({
      ...prev,
      [method]: sanitized,
    }));
  };

  const handlePaymentAmountFocus = (method) => {
    setPaymentAmount((prev) => {
      const numeric = parseCurrency(prev[method] || 0) || 0;
      return {
        ...prev,
        [method]: String(numeric),
      };
    });
  };

  const handlePaymentAmountBlur = (method) => {
    setPaymentAmount((prev) => {
      const numeric = parseCurrency(prev[method] || 0) || 0;
      return {
        ...prev,
        [method]: formatCurrency(numeric),
      };
    });
  };

  const togglePaymentMethod = (method) => {
    setPaymentType((prev) => {
      const next = { ...prev, [method]: !prev[method] };
      setPaymentAmount((prevAmount) => {
        const nextAmount = { ...prevAmount };
        if (next[method]) {
          const activeMethods = Object.keys(next).filter((key) => next[key]);
          if (activeMethods.length === 1) {
            nextAmount[method] = formatCurrency(
              parseCurrency(FinalTotal || 0) || 0
            );
          } else if (!nextAmount[method] || nextAmount[method] === "0.00") {
            nextAmount[method] = "0.00";
          }
        } else {
          nextAmount[method] = "0.00";
        }
        return nextAmount;
      });

      if (method === "transfer" && !next[method]) {
        setBankId("");
        setBankMasterId("");
        setPayToAccNo("");
        setPayToAccName("");
        setPayToBranch("");
        setBankInputMode("select");
      }

      if (method === "cheque" && !next[method]) {
        setChequeNo("");
        setChequeName("");
        setChequeBranch("ธนาคารกสิกรไทย");
        setChequeDate("");
      }

      return next;
    });
  };

  const getSelectedPaymentTotal = () =>
    Object.entries(paymentType).reduce((acc, [method, selected]) => {
      if (!selected) {
        return acc;
      }
      const amount = parseCurrency(paymentAmount[method] || 0) || 0;
      return acc + amount;
    }, 0);

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    const loadBankData = async () => {
      try {
        const masterBankData = await getData(
          "Tb_Set_Bank_Master",
          "1 = 1 ORDER BY Bank_Master_Id ASC"
        );
        if (Array.isArray(masterBankData)) {
          setMasterBankDataList(masterBankData);
        }

        const bankCondition =
          "AND Bank_Status = 'Y' AND APAR_Type = 'AP' ORDER BY Bank_Id ASC";
        const bankData = await getDataWithComp("Tb_Set_Bank", bankCondition);
        if (Array.isArray(bankData)) {
          setBankDataList(bankData);
        }
      } catch (error) {
        console.error("โหลดข้อมูลธนาคารไม่สำเร็จ:", error);
      }
    };

    loadBankData();
  }, []);

  useEffect(() => {

    const final = parseCurrency(FinalTotal || 0) || 0;


    const activeMethods = Object.keys(paymentType).filter((key) => paymentType[key]);
    if (activeMethods.length > 0) {

      const currentNums = activeMethods.map((m) => parseCurrency(paymentAmount[m] || 0) || 0);
      const sumCurrent = currentNums.reduce((a, b) => a + b, 0);
      const newAmounts = { ...paymentAmount };

      if (sumCurrent > 0.005) {
        let acc = 0;
        for (let i = 0; i < activeMethods.length; i++) {
          const key = activeMethods[i];
          if (i < activeMethods.length - 1) {
            const value = Math.round(((currentNums[i] / sumCurrent) * final) * 100) / 100;
            newAmounts[key] = formatCurrency(value);
            acc += value;
          } else {
            const last = Math.round((final - acc) * 100) / 100;
            newAmounts[key] = formatCurrency(last);
            acc += last;
          }
        }
      } else {
        const per = Math.round((final / activeMethods.length) * 100) / 100;
        let acc = 0;
        for (let i = 0; i < activeMethods.length; i++) {
          const key = activeMethods[i];
          if (i < activeMethods.length - 1) {
            newAmounts[key] = formatCurrency(per);
            acc += per;
          } else {
            const last = Math.round((final - acc) * 100) / 100;
            newAmounts[key] = formatCurrency(last);
            acc += last;
          }
        }
      }

      setPaymentAmount((prev) => {
        const changed = activeMethods.some((m) => prev[m] !== newAmounts[m]);
        if (!changed) return prev;
        return {
          ...prev,
          ...newAmounts,
        };
      });
    }

    setFormMasterList((prev) => {
      const current = prev && prev[0] ? prev[0] : payMasterModel();
      const apData = {
        docDueDate: current.docDueDate,
        apID: current.apID,
        apCode: current.apCode,
        arID: current.arID,
        arCode: current.arCode,
        apName: parseCurrency(docRefType) === 3 ? current.arName : current.apName,
        apAdd1: current.AP_Add1,
        apAdd2: current.AP_Add2,
        apAdd3: current.AP_Add3,
        apProvince: current.AP_Province,
        apZipcode: current.AP_Zipcode,
        apTaxNo: current.AP_TaxNo,
      };

      if (paymentStatus === "oneTime" || parseCurrency(docRefType) === 4) {
        return [
          {
            ...current,
            ...apData,
            amountPay: formatCurrency(final),
          },
        ];
      } else {
        const count = Math.max(1, parseInt(installmentCount) || 1);
        const perRaw = final / count;
        const newList = [];
        let acc = 0;
        for (let i = 0; i < count; i++) {
          if (i < count - 1) {
            const amt = Math.round(perRaw * 100) / 100;
            newList.push({
              ...payMasterModel(),
              datePay: i === 0 ? current.datePay : null,
              amountPay: formatCurrency(amt),
              docRemark1: "",
              docRemark2: "",
              ...apData,
            });
            acc += amt;
          } else {
            const last = Math.round((final - acc) * 100) / 100;
            newList.push({
              ...payMasterModel(),
              datePay: i === 0 ? current.datePay : null,
              amountPay: formatCurrency(last),
              docRemark1: "",
              docRemark2: "",
              ...apData,
            });
            acc += last;
          }
        }
        if (prev && prev.length > 0) {
          newList[0] = { ...newList[0], ...current };
          newList[0].amountPay = formatCurrency(parseCurrency(newList[0].amountPay));
        }
        return newList;
      }
    });
  }, [FinalTotal, paymentType, paymentStatus, installmentCount, docRefType]);

  const initialize = async () => {
    resetPaymentChannels();
    try {
      // ดึงข้อมูลทั้งหมดจาก API_0301_REC_H
      const recDataList = await getDataWithComp("API_0301_REC_H", "AND (ISNULL(Pay_Status, '') = '13' OR Pay_Id IS NULL) ORDER BY Rec_No DESC");
      if (recDataList && recDataList.length > 0) {
        // สร้างรายการ Rec_No และ Rec_Id จาก recDataList
        const recNos = recDataList.map((record) => record.Rec_No);
        const recIds = recDataList.map((record) => record.Rec_Id);

        // ดึงข้อมูลจาก REC_H โดยใช้ Rec_No ที่ได้จาก API_0301_REC_H
        // และกรองตาม Rec_Status = 2 และ Doc_Status_Paid <> 2 หรือเป็น NULL
        const recHFilterQuery = `
          AND Rec_Status = 2
          AND (Doc_Status_Paid IS NULL OR Doc_Status_Paid <> '2')
          AND Rec_No IN (${recNos.map((no) => `'${no}'`).join(", ")})
        `;
        const recHFiltered = await getDataWithComp("API_0301_REC_H", recHFilterQuery);

        // สร้างชุด Rec_No ที่ผ่านการกรองจาก REC_H
        const filteredRecNos = new Set(recHFiltered.map((record) => record.Rec_No));

        // กรอง recDataList ตาม Rec_No ที่ผ่านการกรอง
        let filteredRecDataList = recDataList.filter((record) => filteredRecNos.has(record.Rec_No));

        // ดึง PAY_D ทั้งหมดที่มี Rec_Id ตรงกับ recDataList
        if (filteredRecDataList.length > 0) {
          // สร้างชุด Rec_Id ที่ต้องเช็ค
          const recIdList = filteredRecDataList.map((record) => String(record.Rec_Id));
          // Query PAY_D เฉพาะ Rec_Id ที่อยู่ใน recIdList
          const payDQuery = `Rec_Id IN (${recIdList.map((id) => `'${id}'`).join(", ")})`;
          const rawPayD = await getData("PAY_D", payDQuery);
          const payDRecords = Array.isArray(rawPayD) ? rawPayD : [];
          // สร้าง Set ของ Rec_Id ที่มีใน PAY_D (แปลงเป็น string)
          const paidRecIds = new Set((payDRecords || []).map((item) => String(item.Rec_Id)));
          // กรอง recDataList โดยตัด Rec_Id ที่มีใน PAY_D ออก (เปรียบเทียบแบบ string)
          filteredRecDataList = filteredRecDataList.filter((record) => !paidRecIds.has(String(record.Rec_Id)));
        }

        if (filteredRecDataList.length > 0) {
          const refDocIds = [
            ...new Set(
              filteredRecDataList
                .map((record) => Number(record?.Ref_DocID))
                .filter((id) => Number.isFinite(id))
            ),
          ];

          if (refDocIds.length > 0) {
            const poCondition = `AND Doc_Id IN (${refDocIds.join(",")})`;
            const poReceiveList = await getDataWithComp("PO_H", poCondition);
            const receiveStatusMap = new Map(
              (poReceiveList || []).map((po) => [
                String(po.Doc_Id),
                Number(po.Doc_Status_Receive),
              ])
            );

            filteredRecDataList = filteredRecDataList.filter((record) => {
              const receiveStatus = receiveStatusMap.get(
                String(record?.Ref_DocID)
              );
              return Number(receiveStatus) === 3;
            });
          } else {
            filteredRecDataList = [];
          }
        }

        // จัดเรียงข้อมูลตาม Rec_No ในลำดับ DESC
        filteredRecDataList.sort((a, b) => b.Rec_No.localeCompare(a.Rec_No));

        // ตั้งค่าผลลัพธ์ที่กรองและจัดเรียงแล้ว
        setRecDataList(filteredRecDataList);
      }

      const poDataList = await getViewPoH();
      if (poDataList && poDataList.length > 0) {
        // กรองเฉพาะ PO ที่ยังจ่ายไม่ครบ (Doc_Status_Paid ไม่ใช่ 3 = จ่ายครบ)
        setPoDataList(poDataList.filter((po) => po.Doc_Status_Paid !== '3' && po.Doc_Status_PaidName === "-"));
      }

      const apDataList = await fetchApList();
      if (apDataList && apDataList.length > 0) {
        setRef_PAY_ID(maxPayNo);
        setDocRef(maxPayNo);
      }

      const itemDataList = await getDataWithComp(
        "Tb_Set_Item",
        "ORDER By Item_Code ASC",
        {
          fields: [
            "Item_Id",
            "Item_Code",
            "Item_Name",
            "Item_Img",
            "Item_Group",
            "Item_Status"
          ]
        }
      );
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      setPayBefore(0);
      setIsPayBefore(false);

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList, recDataList, poDataList);

        const findIdByNo = await getDataWithComp(
          "PAY_H",
          `AND Pay_No = '${maxPayNo}'`
        );

        if (findIdByNo[0].Pay_Id) {
          const image = await getDataWithComp(
            "Upload_File_List",
            `AND DocCode_ID = 4 AND Doc_ID = ${findIdByNo[0].Pay_Id}`
          );

          if (Array.isArray(image) && image.length > 0) {
            setSelectedFiles(image);
          } else {
            setSelectedFiles([]);
          }
        } else {
          setSelectedFiles([]);
        }

        // ค้นหาไฟล์ที่เกี่ยวข้อง
        if (findIdByNo[0].Pay_Type === 1) {
          const getDetailForRec = await getData(
            "PAY_D",
            `Pay_Id = ${findIdByNo[0].Pay_Id}`
          );
          if (getDetailForRec && getDetailForRec.length > 0) {
            const image = await getDataWithComp(
              "Upload_File_List",
              `AND DocCode_ID = 3 AND Doc_ID = ${getDetailForRec[0].Rec_Id}`
            );
            if (Array.isArray(image) && image.length > 0) {
              setSelectedRecFiles(image);
            } else {
              setSelectedRecFiles([]);
            }
          }
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (apDataList, recDataListParam, poDataListParam) => {
    try {
      // ค้นหาข้อมูลที่ตรงกับใน AP_ID ใน apDataList
      const findMaster = await getDataWithComp("PAY_H", "");
      const fromDatabase = findMaster.find((pay) => pay.Pay_No === maxPayNo);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายหรือลูกค้าด้วย ID ที่เกี่ยวข้อง
      let fromViewAp, fromViewAr;
      if (fromDatabase.Pay_Type === 3) {
        const arList = await getDataWithComp("Tb_Set_AR", "ORDER BY AR_Code ASC");
        fromViewAr = Array.isArray(arList)
          ? arList.find((ar) => ar.AR_Id === fromDatabase.AR_Id)
          : undefined;
        if (!fromViewAr) {
          throw new Error("ไม่พบข้อมูลลูกค้า");
        }
      } else {
        fromViewAp = Array.isArray(apDataList)
          ? apDataList.find((ap) => ap.AP_Id === fromDatabase.AP_Id)
          : undefined;
        if (!fromViewAp) {
          throw new Error("ไม่พบข้อมูลผู้ขาย");
        }
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0401_PAY_H", "");
      const fromView = findViewMaster.find((data) => data.Pay_No === maxPayNo);

      if (fromView) {
        setStatusName(fromView.PayStatus_Name);
        setStatusColour(fromView.PayStatus_Colour);
        setSelectedDiscountValueType(
          fromView?.Discount_Value_Type === 1 ? "1" : "2"
        );
      }

      const findPayHistory = await getData(
        "Pay_History",
        `DocCode_Id = 4 AND Doc_Id = ${fromDatabase.Pay_Id}`
      );

      // ค้นหาประเภทการจ่ายหลังอนุมัติแล้ว
      if (parseCurrency(fromView.Pay_Status) === 2) {
        if (findPayHistory && findPayHistory.length > 0) {
          if (findPayHistory.length > 1) {
            setStatusPaidTypeName("จ่ายหลายช่องทาง");
            setStatusPaidTypeColour("#8A3707");
          } else {
            switch (findPayHistory[0].Pay_Type) {
              case 1:
                setStatusPaidTypeName("เงินสด");
                setStatusPaidTypeColour("#13A10E");
                break;
              case 2:
                setStatusPaidTypeName("เงินโอน");
                setStatusPaidTypeColour("#0F6CBD");
                break;
              case 3:
                setStatusPaidTypeName("เช็ค");
                setStatusPaidTypeColour("#BD0F77");
                break;
              default:
                break;
            }
          }
        }
      }

      if (Array.isArray(findPayHistory) && findPayHistory.length > 0) {
        const nextPaymentType = { cash: false, transfer: false, cheque: false };
        const nextPaymentAmount = { cash: "0.00", transfer: "0.00", cheque: "0.00" };
        let nextBankInputMode = "select";
        let nextBankMasterId = "";
        let nextBankId = "";
        let nextPayToAccNo = "";
        let nextPayToAccName = "";
        let nextPayToBranch = "";
        let nextPayDatetime = moment().format("YYYY-MM-DD");
        let nextChequeNo = "";
        let nextChequeName = "";
        let nextChequeBranch = "ธนาคารกสิกรไทย";
        let nextChequeDate = "";

        findPayHistory.forEach((history) => {
          const methodType = Number(history.Pay_Type);
          const formattedAmount = formatCurrency(
            parseCurrency(history.Pay_Amount || 0) || 0
          );

          switch (methodType) {
            case 1: // เงินสด
              nextPaymentType.cash = true;
              nextPaymentAmount.cash = formattedAmount;
              break;
            case 2: // โอนเงิน
              nextPaymentType.transfer = true;
              nextPaymentAmount.transfer = formattedAmount;
              nextPayDatetime = history.Pay_Datetime
                ? moment(history.Pay_Datetime).format("YYYY-MM-DD")
                : nextPayDatetime;
              if (history.Bank_Id) {
                nextBankInputMode = "select";
                nextBankId = String(history.Bank_Id);
              } else {
                nextBankInputMode = "manual";
                nextBankMasterId = history.Bank_Master_Id
                  ? String(history.Bank_Master_Id)
                  : nextBankMasterId;
              }
              nextPayToAccNo = history.Pay_To_Acc_No || nextPayToAccNo;
              nextPayToAccName = history.Pay_To_Acc_Name || nextPayToAccName;
              nextPayToBranch = history.Pay_To_Branch || nextPayToBranch;
              break;
            case 3: // เช็ค
              nextPaymentType.cheque = true;
              nextPaymentAmount.cheque = formattedAmount;
              nextChequeNo = history.Pay_Cheque_No || "";
              nextChequeName = history.Pay_Cheque_Name || "";
              nextChequeBranch =
                history.Pay_Cheque_Branch || nextChequeBranch || "ธนาคารกสิกรไทย";
              nextChequeDate = history.Pay_Cheque_date
                ? moment(history.Pay_Cheque_date).format("YYYY-MM-DD")
                : nextChequeDate;
              nextBankMasterId = history.Bank_Master_Id
                ? String(history.Bank_Master_Id)
                : nextBankMasterId;
              nextPayToAccNo = history.Pay_To_Acc_No || nextPayToAccNo;
              nextPayToAccName = history.Pay_To_Acc_Name || nextPayToAccName;
              nextPayToBranch = history.Pay_To_Branch || nextPayToBranch;
              if (history.Bank_Id) {
                nextBankInputMode = "select";
                nextBankId = String(history.Bank_Id);
              }
              break;
            default:
              break;
          }
        });

        setPaymentType(nextPaymentType);
        setPaymentAmount(nextPaymentAmount);
        setBankInputMode(nextBankInputMode);
        setBankMasterId(nextBankMasterId);
        setBankId(nextBankId);
        setPayToAccNo(formatAccountNo(nextPayToAccNo || ""));
        setPayToAccName(nextPayToAccName);
        setPayToBranch(nextPayToBranch);
        setPayDatetime(nextPayDatetime);
        setChequeNo(nextChequeNo);
        setChequeName(nextChequeName);
        setChequeBranch(nextChequeBranch || "ธนาคารกสิกรไทย");
        setChequeDate(nextChequeDate);
      } else {
        resetPaymentChannels();
      }

      handleChangePayType(String(fromDatabase.Pay_Type));

      if (fromDatabase.IsVat === 1) {
        setIsVatChecked(true);
      }
      const getWtaxHResponse = await getData(
        "WTAX_H",
        `Ref_PAY_ID = ${fromDatabase.Pay_Id}`
      );
      if (!getWtaxHResponse || getWtaxHResponse.length === 0) {
        console.warn("ไม่พบข้อมูล WTAX_H สำหรับ Pay_Id:", fromDatabase.Pay_Id);
      }
      const firstWtaxType = Array.isArray(getWtaxHResponse) && getWtaxHResponse.length > 0
        ? getWtaxHResponse[0]?.WTAX_Type
        : undefined;
      if (firstWtaxType !== undefined) {
        setSelectedOption(firstWtaxType);
      }
      const wtaxDResponses = await Promise.all(
        (getWtaxHResponse || []).map(async (wtaxH) => {
          const wtaxId = wtaxH.WTAX_Id;
          return await getData(
            "WTAX_D",
            `WTax_Id = ${wtaxId} ORDER BY "WTAXDT_ID" ASC`
          );
        })
      );

      // ใช้ `flatMap()` แปลงข้อมูล WTAX_D รวมกันทั้งหมด
      const updatedTaxData = wtaxDResponses.flatMap((wtaxDData, index) =>
        wtaxDData.map((item, idx) => ({
          id: index * 100 + idx + 1, // ป้องกัน `id` ซ้ำกัน
          type: item?.WTAX_TypeNo || "",
          percent: item?.WTAX_Percent || 0,
          date: item?.WTAX_Date
            ? moment(item.WTAX_Date).format("YYYY/MM/DD")
            : "",
          amount: item?.WTAX_Pay || 0.0,
          tax: item?.WTAX_Tax || 0,
          remark: item?.WTAX_Desc || "",
        }))
      );

      // อัปเดต state
      setTaxData(updatedTaxData);
      setTotalWT(fromDatabase?.Total_WT);
      setDisTotal(fromDatabase?.Total_Dis_Footer);
      setInputValueTotalWT(parseCurrency(fromDatabase?.Total_WT));
      setInputValuedisTotal(parseCurrency(fromDatabase?.Total_Dis_Footer));
      setFormMasterList([
        {
          ...mapDatabaseToFormMasterList(fromDatabase),
          apName:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Name
              : fromViewAp.AP_Name,
          apAdd1:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add1
              : fromViewAp.AP_Add1,
          apAdd2:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add2
              : fromViewAp.AP_Add2,
          apAdd3:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add3
              : fromViewAp.AP_Add3,
          apProvince:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Province
              : fromViewAp.AP_Province,
          apZipcode:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Zipcode
              : fromViewAp.AP_Zipcode,
          apTaxNo:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_TaxNo
              : fromViewAp.AP_TaxNo,

          amountPay: parseCurrency(fromDatabase.Total_Pay_Per),
        },
      ]);

      // ดึงข้อมูลใบแม่และใบลูก (งวดแรก จนถึง งวดอื่นๆ)
      const fromMaster = await getDataWithComp(
        "PAY_H",
        `AND Pay_Id = ${fromDatabase.Pay_Id} AND Ref_DocID IS NULL`
      );
      const fromSubMaster = await getDataWithComp(
        "PAY_H",
        `AND Ref_DocID = ${fromDatabase.Pay_Id}`
      );
      let totalPayPer = 0;
      if (fromMaster.length > 0) {
        // กรณีมีใบแม่
        // คำนวณ Total_Pay_Per ของลูก ๆ (เฉพาะที่ Pay_Status = 1)
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            if (fromSubMaster[i].Pay_Status !== 2) {
              totalPayPer += parseCurrency(fromSubMaster[i].Total_Pay_Per);
            }
          }
        }
        // รวม Total_Pay_Per จากใบแม่ แต่เฉพาะที่ Pay_Status = 1
        if (fromMaster[0].Pay_Status !== 2) {
          totalPayPer += parseCurrency(fromMaster[0].Total_Pay_Per);
        }
      } else {
        // กรณีใบลูก
        // ค้นหาใบแม่จาก Ref_DocID ของใบลูก และเอาแม่มาคำนวณด้วย
        const parentId = fromDatabase?.Ref_DocID;
        if (parentId) {
          const parentMaster = await getDataWithComp(
            "PAY_H",
            `AND Pay_Id = ${parentId} AND Ref_DocID IS NULL`
          );
          if (parentMaster && parentMaster.length > 0) {
            const parentSubMaster = await getDataWithComp(
              "PAY_H",
              `AND Ref_DocID = ${parentMaster[0].Pay_Id}`
            );
            // รวม Total_Pay_Per จากใบลูก แต่เฉพาะที่ Pay_Status = 1
            if (parentSubMaster.length > 0) {
              for (let i = 0; i < parentSubMaster.length; i++) {
                if (parentSubMaster[i].Pay_Status !== 2) {
                  totalPayPer += parseCurrency(parentSubMaster[i].Total_Pay_Per);
                }
              }
            }
            // รวม Total_Pay_Per จากใบแม่ แต่เฉพาะที่ Pay_Status = 1
            if (parentMaster[0].Pay_Status !== 2) {
              totalPayPer += parseCurrency(parentMaster[0].Total_Pay_Per);
            }
          }
        }

      }

      // ตั้งค่า OutstandingBalance เป็นผลรวมที่ได้
      setOutstandingBalance(totalPayPer);

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getData('PAY_D', `Pay_Id = ${fromDatabase.Pay_Id} ORDER BY Item_Code ASC`);

      // แยกย้ายกันนะจ๊ะ โหลดข้อมูลตามประเภทการจ่ายเงิน
      if (String(fromDatabase.Pay_Type) === "1") {
        const recIds = [
          ...new Set(
            fromDetail
              .map((d) => {
                const raw = d?.Rec_Id ?? d?.rec_id ?? d?.RecId;
                return raw !== null && raw !== undefined
                  ? String(raw).trim()
                  : null;
              })
              .filter(Boolean)
          ),
        ];

        const recSelected = [];
        for (const recId of recIds) {
          try {
            const recHList = await getDataWithComp(
              "API_0301_REC_H",
              `AND Rec_Id = ${parseCurrency(recId, 10)}`
            );
            if (recHList && recHList.length > 0) {
              recSelected.push(recHList[0]);
            }
          } catch (err) {
            console.warn(`Failed to fetch REC_H for Rec_Id ${recId}:`, err);
          }
        }

        if (recSelected.length > 0) {
          await onRowSelectRec(recSelected);

          const recNos = recSelected.map((r) => r?.Rec_No).filter(Boolean);
          setFormMasterList((prev) =>
            prev.map((m) => ({
              ...m,
              refDoc:
                recNos.length === 1
                  ? String(recNos[0])
                  : `ใบรับสินค้าจำนวน ${recNos.length} ใบ`,
            }))
          );
        } else {
          console.warn("No REC_H records found for PAY_D Rec_Ids");
        }
      } else if (String(fromDatabase.Pay_Type) === "4") {
        const poSelected = fromDetail
          .map((detail) =>
            (Array.isArray(poDataListParam) ? poDataListParam : []).find(
              (po) => po.Doc_ID === parseCurrency(detail.Rec_Id, 10)
            )
          )
          .filter(Boolean);
        await onRowSelectPo(poSelected);
      } else if (
        (String(fromDatabase.Pay_Type) === "2" || String(fromDatabase.Pay_Type) === "3")
      ) {
        // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
        const createNewRow = (index, itemSelected) => {
          const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
          const itemPriceUnit =
            parseCurrency(itemSelected.Item_Price_Unit) || 0;
          const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
          let itemTotal = itemQty * itemPriceUnit;

          if (itemSelected.Item_DisType === 2) {
            itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
          } else {
            itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
          }

          return {
            ...payDetailModel(index + 1),
            recDtId: itemSelected.DT_Id,
            recId: itemSelected.Rec_Id,
            line: itemSelected.Line,
            itemId: itemSelected.Item_Id,
            recNo: itemSelected.Rec_No,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(itemQty),
            itemUnit: itemSelected.Item_Unit,
            itemPriceUnit: formatCurrency(itemPriceUnit),
            itemDiscount: formatCurrency(itemDiscount),
            itemDisType: String(itemSelected.Item_DisType),
            itemTotal,
            itemStatus: itemSelected.Item_Status,
            whId: itemSelected.WH_ID,
            whName: itemSelected.WH_Name,
            zoneId: itemSelected.Zone_ID,
            ltId: itemSelected.LT_ID,
            dsSeq: itemSelected.DS_SEQ,
            itemDesc: itemSelected.Item_Desc,
          };
        };

        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const mapDatabaseToFormMasterList = (database) => ({
    docRefType: database.Pay_Type,
    datePay: database.Doc_PayDate,
    amountPay: parseCurrency(database.Total_Pay_Per),
    payId: database.Pay_Id,
    payNo: database.Pay_No,
    payDate: database.Pay_Date || null,
    docDueDate: database.Doc_DueDate || null,
    docPayDate: database.Doc_PayDate || null,
    payStatus: parseCurrency(database.Pay_Status, 10),
    payType: database.Pay_Type,
    refDocID: database.Ref_DocID,
    refDoc: database.Ref_Doc,
    refDocDate: database.Ref_DocDate,
    compId: database.Comp_Id,
    refProjectID: database.Ref_ProjectID,
    refProjectNo: database.Ref_ProjectNo,
    transportType: database.Transport_Type,
    docRemark1: database.Doc_Remark1,
    docRemark2: database.Doc_Remark2,
    apID: database.AP_Id,
    apCode: database.AP_Code,
    arID: database.AR_Id,
    arCode: database.AR_Code,
    actionHold: database.Action_Hold,
    discountValue: database.Discount_Value,
    discountValueType: database.Discount_Value_Type,
    discountCash: database.Discount_Cash,
    discountCashType: database.Discount_Cash_Type,
    discountTransport: database.Discount_Transport,
    discountTransportType: database.Discount_Transport_Type,
    isVat: database.IsVat,
    docSEQ: database.Doc_SEQ,
    creditTerm: database.CreditTerm,
    creditTerm1Day: database.CreditTerm1Day,
    creditTerm1Remark: database.CreditTerm1Remark,
    creditTerm2Remark: database.CreditTerm2Remark,
    accCode: database.ACC_Code,
    empName: database.EmpName,
    createdDate: setCreateDateTime(database.Created_Date || null),
    createdByName: database.Created_By_Name,
    createdById: database.Created_By_Id,
    updateDate: setCreateDateTime(database.Update_Date || null),
    updateByName: database.Update_By_Name,
    updateById: database.Update_By_Id,
    approvedDate: setCreateDateTime(database.Approved_Date || null),
    approvedByName: database.Approved_By_Name,
    approvedById: database.Approved_By_Id,
    cancelDate: setCreateDateTime(database.Cancel_Date || null),
    cancelByName: database.Cancel_By_Name,
    cancelById: database.Cancel_By_Id,
    approvedMemo: database.Approved_Memo,
    printedStatus: database.Printed_Status,
    printedDate: setCreateDateTime(database.Printed_Date || null),
    printedBy: database.Printed_By,
  });

  const persistPaymentHistory = async (payId) => {
    if (!payId) {
      return;
    }

    const selectedMethods = Object.entries(paymentType).filter(
      ([, selected]) => selected
    );
    const hasAmount = selectedMethods.some(
      ([method]) => (parseCurrency(paymentAmount[method] || 0) || 0) > 0
    );

    try {
      await deleteData(
        "Pay_History",
        `WHERE DocCode_Id = 4 AND Doc_Id = ${payId}`
      );

      if (!hasAmount) {
        return;
      }

      const paymentTypeMap = {
        cash: 1,
        transfer: 2,
        cheque: 3,
      };

      for (const [method] of selectedMethods) {
        const numericAmount = parseCurrency(paymentAmount[method] || 0) || 0;
        if (numericAmount <= 0) {
          continue;
        }

        let bankMasterValue = null;
        let bankIdValue = null;
        let payToAccNoValue = null;
        let payToAccNameValue = null;
        let payToBranchValue = null;

        if (method === "transfer" || method === "cheque") {
          if (bankInputMode === "select" && bankId) {
            const parsedBankId = Number(bankId);
            bankIdValue = Number.isNaN(parsedBankId) ? null : parsedBankId;
          } else {
            const parsedBankMasterId = Number(bankMasterId);
            bankMasterValue = Number.isNaN(parsedBankMasterId)
              ? null
              : parsedBankMasterId;
            payToAccNoValue = payToAccNo || null;
            payToAccNameValue = payToAccName || null;
            payToBranchValue = payToBranch || null;
          }

          if (!payToAccNoValue) {
            payToAccNoValue = payToAccNo || null;
          }
          if (!payToAccNameValue) {
            payToAccNameValue = payToAccName || null;
          }
          if (!payToBranchValue) {
            payToBranchValue = payToBranch || null;
          }
        }

        const isCheque = paymentTypeMap[method] === 3;
        const datetimeSource =
          isCheque && chequeDate ? chequeDate : payDatetime;

        const payload = {
          doc_code_id: 4,
          doc_id: payId,
          pay_type: paymentTypeMap[method],
          pay_amount: numericAmount,
          pay_remark: null,
          // Use local time without forcing +7 offset
          pay_datetime: moment(datetimeSource || new Date()).format('YYYY-MM-DD HH:mm:ss'),
          pay_by: window.localStorage.getItem("name"),
          pay_to_acc_no: payToAccNoValue,
          pay_to_branch: payToBranchValue,
          pay_to_acc_name: payToAccNameValue,
          pay_cheque_no: isCheque ? chequeNo || null : null,
          pay_cheque_name: isCheque ? chequeName || null : null,
          pay_cheque_branch: isCheque
            ? chequeBranch || "ธนาคารกสิกรไทย"
            : null,
          pay_cheque_date:
            isCheque && chequeDate
              ? moment(chequeDate).format('YYYY-MM-DD HH:mm:ss')
              : null,
          pay_cheque_type: null,
          comp_id: window.localStorage.getItem("company"),
          bank_master_id: bankMasterValue,
          bank_id: bankIdValue,
          doc_ref: null,
        };

        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
          payload,
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );
      }
    } catch (error) {
      console.error("persistPaymentHistory error:", error);
      throw error;
    }
  };

  const getMaxWtaxNo = async () => {
    const currentYear = moment().year() + 543;
    const shortYear = currentYear.toString().slice(-2);
    const currentMonth = moment().format("MM");
    const prefix = `WT${shortYear}${currentMonth}`;

    // ดึงหมายเลขที่สูงสุดที่ตรงกับ prefix ปัจจุบัน (ปีและเดือนเดียวกัน)
    const getMaxWtaxNoResponse = await getDataWithComp(
      "WTAX_H",
      `AND WTAX_No LIKE '${prefix}%' ORDER BY WTAX_No DESC`
    );

    let newWTaxNo = `${prefix}001`;

    if (getMaxWtaxNoResponse && getMaxWtaxNoResponse.length > 0) {
      const lastWTaxNo = getMaxWtaxNoResponse[0]?.WTAX_No || "";

      if (lastWTaxNo.startsWith(prefix)) {
        const lastNumber = parseInt(lastWTaxNo.slice(-3), 10) || 0;
        const nextNumber = String(lastNumber + 1).padStart(3, "0");
        newWTaxNo = `${prefix}${nextNumber}`;
      }
    }

    return newWTaxNo;
  };

  const updateWtaxRecords = async (payId, taxData) => {
    try {
      let getWtaxIdResponse = await getDataWithComp(
        "WTAX_H",
        `AND Ref_PAY_ID = ${payId}`
      );

      // ถ้าไม่มี WTAX_H มาก่อน ให้สร้างใหม่
      if (!getWtaxIdResponse || getWtaxIdResponse.length === 0) {
        console.log("❗ ไม่พบ WTAX_H จะสร้างใหม่...");

        for (const taxItem of taxData) {
          if (
            !taxItem.amount ||
            parseFloat(parseCurrency(taxItem.amount)) === 0
          ) {
            console.warn(
              "⚠ ข้ามการสร้าง WTAX_H เพราะ amount เป็น 0 หรือไม่ถูกต้อง",
              taxItem
            );
            continue;
          }

          const newWTaxNo = await getMaxWtaxNo(); // สร้าง WTax_No ใหม่

          const wtaxHData = {
            WTax_No: newWTaxNo,
            Ref_Doc: maxPayNo,
            AP_Id: formMasterList[0].apID,
            Ref_PAY_ID: payId,
            WTax_Type: selectedOption,
            WTax_Total: parseFloat(parseCurrency(taxItem.amount)).toFixed(2),
            WTax_Total_Tax: parseFloat(parseCurrency(taxItem.tax)).toFixed(2),
            WTax_Created_Date: new Date(),
            WTax_Created_By: window.localStorage.getItem("name"),
            Comp_Id: window.localStorage.getItem("company"),
            WTAX_Status: 1,
          };

          const insertWtaxHRes = await insertData(
            "WTAX_H",
            Object.keys(wtaxHData).join(", "),
            Object.values(wtaxHData)
          );

          if (insertWtaxHRes?.status !== "OK") {
            getAlert("FAILED", "ไม่สามารถสร้าง WTAX_H ใหม่ได้");
            return;
          }

          // ดึง WTAX_Id ที่สร้างขึ้น
          getWtaxIdResponse = await getDataWithComp(
            "WTAX_H",
            `AND WTax_No = '${newWTaxNo}'`
          );
        }
      }

      // อัปเดตข้อมูล WTAX_H ที่มีอยู่
      for (const [index, wtaxH] of getWtaxIdResponse.entries()) {
        if (index >= taxData.length) {
          console.warn(
            `❗ ไม่มี taxData สำหรับ WTax_Id: ${wtaxH.WTAX_Id}, ข้ามการอัปเดต`
          );
          continue;
        }

        const wtaxId = wtaxH.WTAX_Id;
        const relevantTaxItem = taxData[index];

        if (
          !relevantTaxItem ||
          parseFloat(parseCurrency(relevantTaxItem.amount || 0)) === 0
        ) {
          console.warn(
            `⚠ ข้ามการ insertData WTAX_D เพราะ amount เป็น 0 หรือข้อมูลไม่ถูกต้อง`,
            relevantTaxItem
          );
          continue;
        }

        const wtaxHData = {
          Ref_Doc: maxPayNo,
          AP_Id: formMasterList[0].apID,
          Ref_PAY_ID: payId,
          WTax_Type: selectedOption,
          WTax_Total: parseFloat(parseCurrency(relevantTaxItem.amount)).toFixed(
            2
          ),
          WTax_Total_Tax: parseFloat(
            parseCurrency(relevantTaxItem.tax)
          ).toFixed(2),
          WTax_Updated_Date: new Date(),
          WTax_Updated_By: window.localStorage.getItem("name"),
        };

        await updateData("WTAX_H", wtaxHData, { WTax_Id: wtaxId });
        await deleteData("WTAX_D", `WHERE WTax_Id = ${wtaxId}`);

        const wtaxDData = {
          WTax_Id: wtaxId,
          WTax_TypeNo: relevantTaxItem.type,
          WTax_Desc: relevantTaxItem.remark || "",
          WTax_Percent: parseFloat(parseCurrency(relevantTaxItem.percent)),
          // Store date without forcing timezone offset; keep as local date
          WTax_Date: relevantTaxItem.date
            ? new Date(moment(relevantTaxItem.date).format('YYYY-MM-DD'))
            : new Date(),
          WTax_Pay: parseFloat(parseCurrency(relevantTaxItem.amount)).toFixed(
            2
          ),
          WTax_Tax: parseFloat(parseCurrency(relevantTaxItem.tax)).toFixed(2),
        };

        try {
          await insertData(
            "WTAX_D",
            Object.keys(wtaxDData).join(", "),
            Object.values(wtaxDData)
          );
        } catch (error) {
          console.error("❌ insertData ล้มเหลว:", error);
        }
      }
    } catch (error) {
      getAlert("FAILED", "เกิดข้อผิดพลาดในการอัปเดต WTAX");
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (
        (parseCurrency(docRefType) === 1 || parseCurrency(docRefType) === 2) &&
        !formMasterList[0].apID &&
        !formMasterList[0].apCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      if (
        parseCurrency(docRefType) === 3 &&
        !formMasterList[0].arID &&
        !formMasterList[0].arCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบจำนวนเงินสำหรับ docRefType = 4 (เบิกล่วงหน้า/อื่นๆ)
      if (parseCurrency(docRefType) === 4) {
        const amountPay = parseCurrency(formMasterList[0].amountPay || 0);
        const finalTotal = parseCurrency(FinalTotal || 0);

        if (amountPay <= 0) {
          getAlert("FAILED", "กรุณาระบุจำนวนเงิน ต้องมากกว่า 0 บาท");
          return;
        }

        if (amountPay > finalTotal) {
          getAlert("FAILED", "จำนวนเงินจ่าย (" + formatCurrency(amountPay) + " บาท) ไม่สามารถเกินยอดรวมทั้งสิ้น (" + formatCurrency(finalTotal) + " บาท)");
          return;
        }
      }

      // ตรวจสอบว่ามีการเลือกวันที่ครบทุกงวดหรือไม่ และ ต้องห้ามเป็นวันเดียวกัน
      let dateSet = new Set();
      for (let i = 0; i < formMasterList.length; i++) {
        if (!formMasterList[i].datePay) {
          getAlert("FAILED", "กรุณาเลือกวันที่จ่ายงวดที่ " + (i + 1));
          return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ไม่มีการเลือกวันที่
        }

        // ตรวจสอบจำนวนเงินในตารางจ่าย (สำหรับจ่ายล่วงหน้า docRefType = 2)
        if (parseCurrency(docRefType) === 2) {
          const amountPay = parseCurrency(formMasterList[i].amountPay || 0);
          if (amountPay <= 0) {
            getAlert("FAILED", "จำนวนเงินจ่ายงวดที่ " + (i + 1) + " ต้องมากกว่า 0 บาท");
            return;
          }
        }

        if (formMasterList[i].datePay) {
          let datePay = formMasterList[i].datePay;

          // ตรวจสอบวันที่จ่าย ต้องห้ามเป็นวันเดียวกัน
          if (dateSet.has(datePay)) {
            getAlert(
              "FAILED",
              "วันที่จ่ายงวดที่ " +
              (i + 1) +
              " ซ้ำกับวันที่จ่ายในงวดก่อนหน้านี้"
            );
            return; // หยุดการทำงานของฟังก์ชันหากวันที่ซ้ำ
          }

          dateSet.add(datePay);
        }
      }

      // ใบจ่าย Set วันที่ชำระ แต่ละใบเป็นวันที่ใบรับ ที่น้อยที่สุด + CreditTerm (ดักเฉพาะกรณีที่บันทึกใบจ่ายด้วยใบรับ)
      let newDocDueDate = formMasterList[0].docDueDate;

      let dateString = formMasterList[0].datePay;

      // แปลงเป็น Date object ก่อน
      let date = new Date(dateString);

      // ดึงค่าวัน เดือน ปี (พ.ศ.)
      let day = String(date.getDate()).padStart(2, "0");
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let yearBE = String(date.getFullYear() + 543);

      // สร้าง PayNo
      let givenDate = "PAY" + yearBE.substring(2, 4) + month;

      // สร้างวันที่แบบแสดงผล 05-05-2568
      let displayDate = `${day}-${month}-${yearBE}`;

      const findMaxPayNo = await getDataWithComp(
        "PAY_H",
        `AND Pay_No LIKE '${givenDate}%' ORDER BY Pay_No DESC`
      );
      const maxPay = getMaxPayNo(findMaxPayNo, displayDate);
      let newMaxPay = maxPay;

      // เก็บข้อมูลสำหรับใบแรกไว้เสมอ เช่น Ref_DocID, Ref_Doc, Ref_DocDate
      const incrementedPayNo = incrementPayNoWithIndex(newMaxPay, 0);
      let refDocID = null;
      let refDoc = incrementedPayNo;
      let refDocDate = formMasterList[0].payDate || null;

      // บันทึก formMasterList[0] ก่อน
      const formData = {
        pay_no: incrementedPayNo,
        pay_date: formMasterList[0].payDate,
        doc_due_date: newDocDueDate ? moment(newDocDueDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        doc_pay_date: formMasterList[0].datePay,
        pay_status: parseCurrency("1", 10),
        pay_type: parseCurrency(docRefType, 10),
        ref_doc_id: null,
        ref_doc: null,
        ref_doc_date: null,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList[0].refProjectID,
        ref_project_no: formMasterList[0].refProjectNo,
        transport_type: formMasterList[0].transportType,
        doc_remark1: formMasterList[0].docRemark1,
        doc_remark2: formMasterList[0].docRemark2,
        ap_id: formMasterList[0].apID,
        ap_code: formMasterList[0].apCode,
        ar_id: formMasterList[0].arID,
        ar_code: formMasterList[0].arCode,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList[0].discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList[0].discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList[0].discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency("0", 10),
        credit_term_1_day: parseCurrency("0", 10),
        credit_term_1_remark: formMasterList[0].creditTerm1Remark,
        credit_term_2_remark: formMasterList[0].creditTerm2Remark,
        acc_code: "0000",
        emp_name: null,
        created_date: formatThaiDateUiToDate(formMasterList[0].createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        cancel_memo: null,
        total_pay_per: docRefType === "4" ? parseCurrency(formMasterList[0].amountPay) : formMasterList.length > 1 ? parseCurrency(formMasterList[0].amountPay) : parseCurrency(FinalTotal),
        total_wt: totalWT,
        isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
          ? "Y"
          : "N",
        total_dis_footer: parseCurrency(disTotal),
        total_pay_netTotal: docRefType === "4" ? parseCurrency(formMasterList[0].amountPay) : formMasterList.length > 1 ? parseCurrency(formMasterList[0].amountPay) : parseCurrency(FinalTotal),
      };

      const firstResponse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-pay-h`,
        formData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (firstResponse.data.status !== "OK") {
        getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลรายการแรกได้");
        return;
      }

      // Fetch ข้อมูลสำหรับ Ref_DocID
      const getPayIdResponse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/get-by-pay-no`,
        {
          table: "PAY_H",
          pay_no: incrementedPayNo,
          comp_id: window.localStorage.getItem("company"),
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // เก็บ Pay_Id ของใบแรกเอาไว้ใน refDocID และทำการบันทึก Detail ของใบแรกไปก่อน
      if (getPayIdResponse && getPayIdResponse.data.length > 0) {
        refDocID = getPayIdResponse.data[0].Pay_Id;

        const detailPromises = formDetailList.map(async (item, index) => {
          let payId = parseCurrency(getPayIdResponse.data[0].Pay_Id, 10);
          const resolvedRecId = resolveRecIdFromDetail(item);

          const formDetailData = {
            pay_id: payId,
            rec_dt_id: item.recDtId,
            rec_id: resolvedRecId,
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype:
              item.itemDisType === "1"
                ? parseCurrency("1", 10)
                : parseCurrency("2", 10),
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1", 10),
            wh_id: parseCurrency(item.whId, 10),
            zone_id: parseCurrency("1", 10),
            lt_id: parseCurrency("1", 10),
            ds_seq: formatDateTime(new Date()),
            item_desc: item.itemDesc,
          };

          // ยอดสถานะค้างจ่ายของใบรับสินค้า
          if (String(formData.pay_type) === "1" && resolvedRecId) {
            await updateStatusByNo(
              "REC_H", // table: ชื่อตาราง
              "Doc_Status_Paid", // field: ชื่อฟิลด์
              1, // status: สถานะที่ต้องการอัพเดท
              `WHERE Rec_Id = '${resolvedRecId}'` // where: เงื่อนไขในการอัพเดท
            );
          } else if (String(formData.pay_type) === "4" && resolvedRecId) {
            await updateStatusByNo(
              "PO_H", // table: ชื่อตาราง
              "Doc_Status_Paid", // field: ชื่อฟิลด์
              2, // status: สถานะที่ต้องการอัพเดท
              `WHERE Doc_Id = '${resolvedRecId}'` // where: เงื่อนไขในการอัพเดท
            );
          }

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        // const totalSelected = getSelectedPaymentTotal() || 0;
        // const docTotal = parseCurrency(FinalTotal || 0) || 0;
        // const hasPaymentChannelSelected = Object.values(paymentType || {}).some(Boolean);
        // if (hasPaymentChannelSelected && Math.abs(totalSelected - docTotal) >= 0.01) {
        //   getAlert("FAILED", "ต้องจ่ายตามจำนวนให้ถูกด้วย");
        //   return;
        // }

        await persistPaymentHistory(
          Number(getPayIdResponse.data[0].Pay_Id)
        );
      } else {
        console.error("ไม่สามารถรับข้อมูล Pay_Id ได้");
        return;
      }

      // *********************************************************************************************
      // ถ้า formMasterList มีมากกว่า 1 ข้อมูล และให้เริ่มต้นบันทึกแต่ข้อมูลที่ [1] เป็นต้นไป
      if (formMasterList.length > 1) {
        for (let i = 1; i < formMasterList.length; i++) {
          // ใบจ่าย Set วันที่ชำระ แต่ละใบเป็นวันที่ใบรับ ที่น้อยที่สุด + CreditTerm (ดักเฉพาะกรณีที่บันทึกใบจ่ายด้วยใบรับ)
          // if (parseCurrency(docRefType) === 1) {
          //     // สมมติว่า `minReceiptDate` คือวันที่ใบรับที่น้อยที่สุด
          //     let minReceiptDate = newDocDueDate;

          //     // แปลงวันที่ไทยให้เป็นวันที่ที่ Moment เข้าใจ
          //     let minDateMoment = moment(minReceiptDate, 'DD-MM-YYYY');

          //     // เพิ่ม CreditTerm เข้าไปในวันที่ใบรับที่น้อยที่สุด
          //     newDocDueDate = minDateMoment.add(creditTerm, 'days').format('DD-MM-YYYY');
          // }

          // บันทึก Master
          let formMasterData = formMasterList[i];

          // // หาค่าสูงสุดของ PayNo ใน PAY_H ก่อนบันทึก
          // let dateString = formMasterList[i].datePay;
          // let givenDate =
          //   "PAY" +
          //   dateString.substring(6, 10).substring(2) +
          //   dateString.substring(3, 5);
          // const findMaxPayNo = await getDataWithComp(
          //   "PAY_H",
          //   `AND Pay_No LIKE '${givenDate}%' ORDER BY Pay_No DESC`
          // );
          // const maxPay = getMaxPayNo(findMaxPayNo, dateString);
          // let incrementedPayNo = maxPay;

          let findMaxPayNoNew = await getDataWithComp(
            "PAY_H",
            `AND Pay_No LIKE '${givenDate}%' ORDER BY Pay_No DESC`
          );
          let maxPayNew = getMaxPayNo(findMaxPayNoNew, displayDate);
          let newMaxPayNew = maxPayNew;

          // บันทึกรายการที่เหลือใน formMasterList
          let formData = {
            pay_no: newMaxPayNew,
            pay_date: formMasterData.payDate,
            doc_due_date: formMasterData.datePay,
            doc_pay_date: formMasterData.datePay,
            pay_status: parseCurrency("1", 10),
            pay_type: parseCurrency(docRefType, 10),
            ref_doc_id: refDocID,
            ref_doc: refDoc,
            ref_doc_date: refDocDate,
            comp_id: window.localStorage.getItem("company"),
            ref_project_id: formMasterData.refProjectID,
            ref_project_no: formMasterData.refProjectNo,
            transport_type: formMasterData.transportType,
            doc_remark1: formMasterData.docRemark1,
            doc_remark2: formMasterData.docRemark2,
            ap_id: formMasterData.apID,
            ap_code: formMasterData.apCode,
            ar_id: formMasterData.arID,
            ar_code: formMasterData.arCode,
            action_hold: parseCurrency("0", 10),
            discount_value: parseCurrency(formMasterData.discountValue || 0.0),
            discount_value_type: parseCurrency(selectedDiscountValueType, 10),
            discount_cash: parseCurrency("0.00"),
            discount_cash_type: formMasterData.discountCashType,
            discount_transport: parseCurrency("0.00"),
            discount_transport_type: formMasterData.discountTransportType,
            is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
            doc_seq: formatDateTime(new Date()),
            credit_term: parseCurrency("0", 10),
            credit_term_1_day: parseCurrency("0", 10),
            credit_term_1_remark: formMasterData.creditTerm1Remark,
            credit_term_2_remark: formMasterData.creditTerm2Remark,
            acc_code: "0000",
            emp_name: null,
            created_date: formatThaiDateUiToDate(formMasterData.createdDate),
            created_by_name: window.localStorage.getItem("name"),
            created_by_id: window.localStorage.getItem("emp_id"),
            update_date: null,
            update_by_name: null,
            update_by_id: null,
            approved_date: null,
            approved_by_name: null,
            approved_by_id: null,
            cancel_date: null,
            cancel_by_name: null,
            cancel_by_id: null,
            approved_memo: null,
            printed_status: "N",
            printed_date: null,
            printed_by: null,
            cancel_memo: null,
            total_pay_per: parseCurrency(formMasterData.amountPay),
            total_wt: totalWT,
            isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
              ? "Y"
              : "N",
            total_dis_footer: parseCurrency(disTotal),
            total_pay_netTotal: parseCurrency(formMasterData.amountPay),
          };

          let additionalResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pay-h`,
            formData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (additionalResponse.data.status !== "OK") {
            getAlert("FAILED", "ไม่สามารถบันทึกรายการที่เหลือได้");
            return;
          }

          let getPayIdResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-by-pay-no`,
            {
              table: "PAY_H",
              pay_no: maxPayNew,
              comp_id: window.localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (getPayIdResponse && getPayIdResponse.data.length > 0) {

            const detailPromises = formDetailList.map(async (item, index) => {
              let payId = parseCurrency(getPayIdResponse.data[0].Pay_Id, 10);
              const resolvedRecId = resolveRecIdFromDetail(item);

              const formDetailData = {
                pay_id: payId,
                rec_dt_id: item.recDtId,
                rec_id: resolvedRecId,
                line: index + 1,
                item_id: item.itemId,
                item_code: item.itemCode,
                item_name: item.itemName,
                item_qty: parseCurrency(item.itemQty),
                item_unit: item.itemUnit,
                item_price_unit: parseCurrency(item.itemPriceUnit),
                item_discount: parseCurrency(item.itemDiscount),
                item_distype:
                  item.itemDisType === "1"
                    ? parseCurrency("1", 10)
                    : parseCurrency("2", 10),
                item_total: parseCurrency(item.itemTotal),
                item_status: parseCurrency("1", 10),
                wh_id: parseCurrency(item.whId, 10),
                zone_id: parseCurrency("1", 10),
                lt_id: parseCurrency("1", 10),
                ds_seq: formatDateTime(new Date()),
                item_desc: item.itemDesc,
              };

              // ยอดสถานะค้างจ่ายของใบรับสินค้า
              if (String(formData.pay_type) === "1" && resolvedRecId) {
                await updateStatusByNo(
                  "REC_H", // table: ชื่อตาราง
                  "Doc_Status_Paid", // field: ชื่อฟิลด์
                  1, // status: สถานะที่ต้องการอัพเดท
                  `WHERE Rec_Id = '${resolvedRecId}'` // where: เงื่อนไขในการอัพเดท
                );
              } else if (String(formData.pay_type) === "4" && resolvedRecId) {
                await updateStatusByNo(
                  "PO_H", // table: ชื่อตาราง
                  "Doc_Status_Paid", // field: ชื่อฟิลด์
                  2, // status: สถานะที่ต้องการอัพเดท
                  `WHERE Doc_Id = '${resolvedRecId}'` // where: เงื่อนไขในการอัพเดท
                );
              }

              return Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
                formDetailData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            });

            await Promise.all(detailPromises);
          }
        }
      }

      if (selectedFiles.length > 0) {
        try {
          const filteredFiles = selectedFiles.filter((file) => {
            if (typeof file === "string") return false;
            return file && typeof file === "object" && file.isPending;
          });

          const converted = await convertToDataUrls(filteredFiles);
          const filesPayload = (converted || []).filter(Boolean);

          if (filesPayload.length > 0) {
            const response = await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/upload-file`,
              {
                comp_id: window.localStorage.getItem("company"),
                doc_id: getPayIdResponse.data[0].Pay_Id,
                DocCode_ID: 4,
                upload_by: window.localStorage.getItem("name"),
                file_status: "Y",
                files: filesPayload,
                doc_no_ref: null,
              }
            );
            if (response.data.status !== "SUCCESS") {
              getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
            }
          }
        } catch (error) {
          getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
        }
      }

      const validTaxData = taxData.filter(
        (item) => parseCurrency(item.amount) > 0
      );

      if (validTaxData.length === 0) {
        callInitialize();
        return;
      }

      for (const taxItem of validTaxData) {
        const newWTaxNo = await getMaxWtaxNo(); // สร้าง WTax_No ใหม่สำหรับแต่ละใบ

        const wtaxHData = {
          WTax_No: newWTaxNo,
          Ref_PAY_ID: refDocID,
          AP_Id: formMasterList[0].apID,
          Ref_Doc: maxPayNo,
          WTax_Type: selectedOption,
          WTax_Total: parseCurrency(taxItem.amount).toFixed(2), // ทศนิยมเข้า DB
          WTax_Total_Tax: parseCurrency(taxItem.tax).toFixed(2),
          WTax_Created_Date: new Date(),
          WTax_Created_By: window.localStorage.getItem("name"),
          WTax_Updated_Date: null,
          WTax_Updated_By: null,
          Comp_Id: window.localStorage.getItem("company"),
          WTAX_Status: 1,
        };

        const insertWtaxHRes = await insertData(
          "WTAX_H",
          Object.keys(wtaxHData).join(", "),
          Object.values(wtaxHData)
        );

        if (insertWtaxHRes?.status !== "OK") {
          getAlert(
            "FAILED",
            "ไม่สามารถบันทึกข้อมูลภาษีหัก ณ ที่จ่าย (WTAX_H) ได้"
          );
          return;
        }

        // ดึง WTAX_Id ที่สร้างขึ้น
        const getWtaxIdResponse = await getDataWithComp(
          "WTAX_H",
          `And WTax_No = '${newWTaxNo}'`
        );

        if (!getWtaxIdResponse || getWtaxIdResponse.length === 0) {
          getAlert("FAILED", "ไม่พบ WTax_Id ที่ถูกสร้างขึ้น");
          return;
        }

        const wtaxId = getWtaxIdResponse[0].WTAX_Id;

        // บันทึก WTAX_D สำหรับ WTAX_H แต่ละใบ

        const wtaxDData = {
          WTax_Id: wtaxId,
          WTax_TypeNo: taxItem.type,
          WTax_Desc: taxItem.remark || "",
          WTax_Percent: parseCurrency(taxItem.percent),
          WTax_Date: moment(taxItem.date).format("YYYY/MM/DD"),
          WTax_Pay: parseFloat(parseCurrency(taxItem.amount)).toFixed(2),
          WTax_Tax: parseFloat(parseCurrency(taxItem.tax)).toFixed(2),
        };

        const insertWtaxDRes = await insertData(
          "WTAX_D",
          Object.keys(wtaxDData).join(", "),
          Object.values(wtaxDData)
        );

        if (insertWtaxDRes?.status !== "OK") {
          getAlert("FAILED", "ไม่สามารถบันทึกข้อมูล WTAX_D ได้");
          return;
        }
      }

      callInitialize();
    } catch (error) {
      console.debug(error);
      getAlert("FAILED", "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (
        (parseCurrency(docRefType) === 1 || parseCurrency(docRefType) === 2) &&
        !formMasterList[0].apID &&
        !formMasterList[0].apCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }
      if (
        parseCurrency(docRefType) === 3 &&
        !formMasterList[0].arID &&
        !formMasterList[0].arCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบจำนวนเงินสำหรับ docRefType = 4 (เบิกล่วงหน้า/อื่นๆ)
      if (parseCurrency(docRefType) === 4) {
        const amountPay = parseCurrency(formMasterList[0].amountPay || 0);
        const finalTotal = parseCurrency(FinalTotal || 0);

        if (amountPay <= 0) {
          getAlert("FAILED", "กรุณาระบุจำนวนเงิน ต้องมากกว่า 0 บาท");
          return;
        }

        if (amountPay > finalTotal) {
          getAlert("FAILED", "จำนวนเงินจ่าย (" + formatCurrency(amountPay) + " บาท) ไม่สามารถเกินยอดรวมทั้งสิ้น (" + formatCurrency(finalTotal) + " บาท)");
          return;
        }
      }

      // ตรวจสอบจำนวนเงินในตารางจ่าย (สำหรับจ่ายล่วงหน้า docRefType = 2)
      if (parseCurrency(docRefType) === 2) {
        for (let i = 0; i < formMasterList.length; i++) {
          const amountPay = parseCurrency(formMasterList[i].amountPay || 0);
          if (amountPay <= 0) {
            getAlert("FAILED", "จำนวนเงินจ่ายงวดที่ " + (i + 1) + " ต้องมากกว่า 0 บาท");
            return;
          }
        }
      }

      // ตรวจสอบว่ามีการเลือกวันที่ครบทุกงวดหรือไม่
      for (let i = 0; i < formMasterList.length; i++) {
        if (!formMasterList[i].datePay) {
          getAlert("FAILED", "กรุณาเลือกวันที่จ่ายงวดที่ " + (i + 1));
          return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ไม่มีการเลือกวันที่
        }
      }

      const formMasterData = {
        pay_no: maxPayNo,
        pay_date: formMasterList[0].payDate,
        doc_due_date: formMasterList[0].docDueDate,
        doc_pay_date: formMasterList[0].datePay,
        pay_status: parseCurrency("1", 10),
        pay_type: parseCurrency(docRefType, 10),
        ref_doc_id: formMasterList[0].refDocID,
        ref_doc: formMasterList[0].refDoc,
        ref_doc_date: formMasterList[0].refDocDate,
        comp_id: formMasterList[0].compId,
        ref_project_id: formMasterList[0].refProjectID,
        ref_project_no: formMasterList[0].refProjectNo,
        doc_remark1: formMasterList[0].docRemark1,
        doc_remark2: formMasterList[0].docRemark2,
        ap_id: parseCurrency(formMasterList[0].apID, 10),
        ap_code: formMasterList[0].apCode,
        ar_id: parseCurrency(formMasterList[0].arID, 10),
        ar_code: formMasterList[0].arCode,
        action_hold: parseCurrency(formMasterList[0].actionHold, 10),
        discount_value: parseCurrency(formMasterList[0].discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency(formMasterList[0].discountCash),
        discount_cash_type: formMasterList[0].discountCashType,
        discount_transport: parseCurrency(formMasterList[0].discountTransport),
        discount_transport_type: formMasterList[0].discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        doc_seq: formMasterList[0].docSEQ,
        credit_term: parseCurrency(formMasterList[0].creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList[0].creditTerm1Day, 10),
        credit_term_1_remark: formMasterList[0].creditTerm1Remark,
        credit_term_2_remark: formMasterList[0].creditTerm2Remark,
        acc_code: formMasterList[0].accCode,
        emp_name: formMasterList[0].empName,
        created_date: formatThaiDateUiToDate(formMasterList[0].createdDate),
        created_by_name: formMasterList[0].createdByName,
        created_by_id: formMasterList[0].createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        cancel_memo: null,
        total_pay_per: parseCurrency(formMasterList[0].amountPay),
        total_wt: totalWT,
        isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
          ? "Y"
          : "N",
        total_dis_footer: parseCurrency(disTotal),
        total_pay_netTotal: parseCurrency(formMasterList[0].amountPay),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-pay-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // #####################################
      // DELETE PAY_D เฉพาะรายการเดียว
      const payId = parseCurrency(formMasterList[0].payId, 10);
      await deleteData("PAY_D", `WHERE Pay_Id = ${payId}`);
      // #####################################

      const detailPromises = formDetailList.map((item, index) => {
        const resolvedRecId = resolveRecIdFromDetail(item);
        const formDetailData = {
          pay_id: payId,
          rec_dt_id: item.recDtId,
          rec_id: resolvedRecId,
          line: index + 1,
          item_id: item.itemId,
          item_code: item.itemCode,
          item_name: item.itemName,
          item_qty: parseCurrency(item.itemQty),
          item_unit: item.itemUnit,
          item_price_unit: parseCurrency(item.itemPriceUnit),
          item_discount: parseCurrency(item.itemDiscount),
          item_distype:
            item.itemDisType === "1"
              ? parseCurrency("1", 10)
              : parseCurrency("2", 10),
          item_total: parseCurrency(item.itemTotal),
          item_status: parseCurrency("1", 10),
          wh_id: parseCurrency(item.whId, 10),
          zone_id: parseCurrency("1", 10),
          lt_id: parseCurrency("1", 10),
          ds_seq: formatDateTime(new Date()),
          item_desc: item.itemDesc,
        };

        return Axios.post(
          `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
          formDetailData,
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );
      });
      await Promise.all(detailPromises);

      // Validate payment channel totals match document total before persisting
      const totalSelectedUpdate = getSelectedPaymentTotal() || 0;
      const docTotalUpdate = parseCurrency(FinalTotal || 0) || 0;
      const hasPaymentChannelSelectedUpdate = Object.values(paymentType || {}).some(Boolean);
      if (hasPaymentChannelSelectedUpdate && Math.abs(totalSelectedUpdate - docTotalUpdate) >= 0.01) {
        getAlert("FAILED", "ต้องจ่ายตามจำนวนให้ถูกด้วย");
        return;
      }

      await persistPaymentHistory(payId);

      await updateWtaxRecords(payId, taxData);

      if (selectedFiles.length > 0) {
        try {
          const filteredFiles = selectedFiles.filter((file) => {
            // กรองไฟล์เก่าออกทั้งหมด (URL และ filename string)
            if (typeof file === "string") {
              return false; // ไม่อัพโหลดไฟล์เก่า (ทั้ง URL และ filename)
            }
            // อัพโหลดเฉพาะไฟล์ใหม่ที่เป็น Object
            return file && typeof file === "object" && file.isPending;
          });

          if (filteredFiles.length > 0) {
            const converted = await convertToDataUrls(filteredFiles);
            const filesPayload = (converted || []).filter(Boolean);

            if (filesPayload.length > 0) {
              const response = await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/upload-file`,
                {
                  comp_id: window.localStorage.getItem("company"),
                  doc_id: formMasterList[0].payId,
                  DocCode_ID: 4,
                  upload_by: window.localStorage.getItem("name"),
                  file_status: "Y",
                  files: filesPayload,
                  doc_no_ref: null,
                }
              );

              if (response.data.status !== "SUCCESS") {
                getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
              }
            }
          }
        } catch (error) {
          getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
        }
      }

      // UPDATE ยอดล่าสุด
      if (docRefType === "4") {
        await updateStatusByNo(
          "PAY_H", // table: ชื่อตาราง
          "Total_Pay_Per", // field: ชื่อฟิลด์
          parseCurrency(formMasterList[0].amountPay), // status: สถานะที่ต้องการอัพเดท
          `WHERE Comp_Id = ${window.localStorage.getItem("company")} AND Pay_No = '${maxPayNo}'` // where: เงื่อนไขในการอัพเดท
        );
      }

      callInitialize();
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // Flow ยกเลิกใหม่จากพี่แบงค์ ระบบต้อง Auto ยกเลิกใบลูก หรือ ที่เกี่ยวข้องกับการจ่ายเป็นงวดทั้งหมด
      // ยกเว้นสถานะที่มีการจ่ายไปแล้ว จะไม่ทำอะไร
      if (formMasterList[0].refDoc !== null) {
        // ใบลูก => ต้องค้นหาเพื่อนๆ และแม่
        const fromMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id = ${formMasterList[0].refDocID} AND Ref_DocID IS NULL`
        );
        const fromSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id <> ${formMasterList[0].payId} AND Ref_DocID = ${formMasterList[0].refDocID}`
        );

        // ตรวจสอบว่าพบข้อมูลจาก fromMaster หรือไม่
        if (fromMaster.length > 0 && fromMaster[0].Pay_Status === 1) {
          let formMasterData = {
            pay_no: fromMaster[0].Pay_No,
            pay_status: parseCurrency("13", 10),
            cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
            cancel_by_name: window.localStorage.getItem("name"),
            cancel_by_id: window.localStorage.getItem("emp_id"),
            comp_id: window.localStorage.getItem("company"),
          };
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
            formMasterData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // หยอด Item_Status = 0 ด้วย
          await handleCancelDetail(fromMaster[0].Pay_Id);
        }

        // ตรวจสอบว่าพบข้อมูลจาก fromSubMaster หรือไม่
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            if (fromSubMaster[i].Pay_Status === 1) {
              let formSubMasterData = {
                pay_no: fromSubMaster[i].Pay_No,
                pay_status: parseCurrency("13", 10),
                cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
                cancel_by_name: window.localStorage.getItem("name"),
                cancel_by_id: window.localStorage.getItem("emp_id"),
                comp_id: window.localStorage.getItem("company"),
              };
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
                formSubMasterData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );

              // หยอด Item_Status = 0 ด้วย
              await handleCancelDetail(fromSubMaster[i].Pay_Id);
            }
          }
        }
      } else {
        // ใบแม่ => ค้นหาแค่ลูกๆ
        const fromSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Ref_DocID = ${formMasterList[0].payId}`
        );

        // ตรวจสอบว่าพบข้อมูลจาก fromSubMaster หรือไม่
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            // เพิ่มดักเงื่อนไขว่า ต้องเป็นสถานะรอจ่ายเท่านั้น
            if (fromSubMaster[i].Pay_Status === 1) {
              let formSubMasterData = {
                pay_no: fromSubMaster[i].Pay_No,
                pay_status: parseCurrency("13", 10),
                cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
                cancel_by_name: window.localStorage.getItem("name"),
                cancel_by_id: window.localStorage.getItem("emp_id"),
                comp_id: window.localStorage.getItem("company"),
              };
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
                formSubMasterData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );

              // หยอด Item_Status = 0 ด้วย
              await handleCancelDetail(fromSubMaster[i].Pay_Id);
            }
          }
        }
      }

      // นอกนั้นคือการยกเลิกใบที่ onRowSelect
      const formMasterData = {
        pay_no: maxPayNo,
        pay_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // หยอด Item_Status = 0 ด้วย
      await handleCancelDetail(formMasterList[0].payId);

      // ถ้าเป็นจ่ายล่วงหน้า ให้ทำการหยอดสถานะย้อนด้วย
      if (docRefType === "4") {
        const resolvedRecId = resolveRecIdFromDetail(formDetailList[0]);
        if (resolvedRecId) {
          await updateStatusByNo(
            "PO_H", // table: ชื่อตาราง
            "Doc_Status_Paid", // field: ชื่อฟิลด์
            1, // status: สถานะที่ต้องการอัพเดท
            `WHERE Doc_Id = '${resolvedRecId}'` // where: เงื่อนไขในการอัพเดท
          );
        }
      }
      if (docRefType === "1") {
        const resolvedRecId = resolveRecIdFromDetail(formDetailList[0]);
        if (resolvedRecId) {
          await updateStatusByNo(
            "REC_H", // table: ชื่อตาราง
            "Doc_Status_Paid", // field: ชื่อฟิลด์
            0, // status: สถานะที่ต้องการอัพเดท
            `WHERE Rec_Id = '${resolvedRecId}'` // where: เงื่อนไขในการอัพเดท
          );
        }
      }

      callInitialize();
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancelDetail = async (payId) => {
    await updateQty(
      "PAY_D",
      `Item_Status = '${parseCurrency("0", 10)}'`,
      `WHERE Pay_Id = ${payId}`
    );
  };

  // Upload File
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedRecFiles, setSelectedRecFiles] = useState([]);
  // Helper: convert file objects to data-URL or keep existing URLs
  const convertToDataUrls = (files) => {
    return Promise.all(
      (files || []).map((f) => {
        if (!f) return null;
        if (typeof f === "string") {
          if (f.startsWith("data:") || f.startsWith("http:") || f.startsWith("https:")) return f;
          return null;
        }
        if (f.dataUrl && typeof f.dataUrl === "string" && f.dataUrl.startsWith("data:")) {
          return f.dataUrl;
        }
        if (f.file) {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target?.result);
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(f.file);
          });
        }
        return null;
      })
    );
  };
  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    if (selectedFiles.length === 0) {
      setOpenUploadAttach(false);
    }
  };

  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedFiles((prev) => [...prev, e.target?.result]);
      };
      reader.readAsDataURL(file);
    }
  }

  const handleBeforeUploadAttach = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = false;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setOpenUploadAttach(true);
  };

  // ฟังก์ชั่นเพิ่มค่า PayNo ด้วย index
  const incrementPayNoWithIndex = (payNo, index) => {
    const prefix = payNo.slice(0, 7); // รวมปีและเดือนใน prefix
    const numPart = parseCurrency(payNo.slice(7)) + index;
    return prefix + numPart.toString().padStart(4, "0");
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงใน formDetailList
  const handleChangeDetail = (index, field, value) => {
    if (isReadOnly) {
      return;
    }

    const updatedList = [...formDetailList];

    updatedList[index][field] = value;

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  const handleFocusMaster = (index, field) => {
    const updatedList = [...formMasterList];
    // กำหนดค่าเริ่มต้นถ้า field เป็น undefined
    const value = updatedList[index][field] || 0;
    updatedList[index][field] = parseCurrency(
      value.toString().replace(/,/g, "")
    );
    setFormMasterList(updatedList);
  };

  const handleBlurMaster = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formMasterList];
    updatedList[index][field] = formattedValue;
    setFormMasterList(updatedList);

    if (docRefType === "4") {
      handleBlurTotalDis();
    }
  };

  const handleFocusDetail = (index, field) => {
    const updatedList = [...formDetailList];
    // กำหนดค่าเริ่มต้นถ้า field เป็น undefined
    const value = updatedList[index][field] || 0;
    updatedList[index][field] = parseCurrency(
      value.toString().replace(/,/g, "")
    );
    setFormDetailList(updatedList);
  };

  const handleBlurDetail = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);
    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงใน formMasterList (action สำหรับตาราง)
  const handleChangeMasterList = (index, field, value) => {
    if (isReadOnly) {
      return;
    }
    // ตรวจสอบว่า field เป็น 'amountPay' และค่าที่กรอกเข้ามาเป็นตัวเลขหรือไม่
    if (field === "amountPay" && !/^\d*\.?\d*$/.test(value)) {
      // แจ้งเตือนหากไม่ใช่ตัวเลข
      // getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    // if (field === "amountPay" && docRefType === "4") {
    //   const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    //   setTotalPrice(numericValue);
    //   setGrandTotal(numericValue);
    //   setFinalTotal(numericValue);
    // }

    const updatedList = [...formMasterList];
    updatedList[index][field] = value;
    setFormMasterList(updatedList);
  };

  const handleChangeDateMasterList = (value, name, index) => {
    if (isReadOnly) {
      return;
    }
    const newValue = typeof value === 'string'
      ? value
      : value && value instanceof moment
        ? value.format('YYYY-MM-DD')
        : value;
    const updatedList = [...formMasterList];
    updatedList[index][name] = newValue;
    setFormMasterList(updatedList);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของเอกสารอ้างอิง
  const handleChangePayType = (value) => {
    if (isReadOnly) {
      return;
    }
    const newPayMasterModel = [payMasterModel()];
    setFormMasterList(newPayMasterModel);
    setFormDetailList([]);
    setTotalPrice(0);
    setReceiptDiscount(0);
    setSubFinal(0);
    setGrandTotal(0);
    setFinalTotal(0);
    setIsVatChecked(false);
    setVatAmount(0);
    setDocRefType(value);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของสถานะจ่าย
  const handlePaymentStatusChange = (status) => {
    if (isReadOnly) {
      return;
    }
    // เก็บค่าของ formMasterList ที่มีอยู่เดิม
    const currentList = formMasterList[0]
      ? formMasterList[0]
      : payMasterModel();

    // เก็บค่า ap ข้อมูลไว้ก่อน
    const apData = {
      apID: currentList.apID,
      apCode: currentList.apCode,
      apName: currentList.apName,
      apAdd1: currentList.apAdd1,
      apAdd2: currentList.apAdd2,
      apAdd3: currentList.apAdd3,
      apProvince: currentList.apProvince,
      apZipcode: currentList.apZipcode,
      apTaxNo: currentList.apTaxNo,
    };

    if (status === "oneTime") {
      // ตั้งค่าให้กับรายการเดียว โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0
      setFormMasterList([
        {
          ...currentList,
          amountPay: formatCurrency(grandTotal),
          docRemark1: "",
          docRemark2: "",
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        },
      ]);
      setInstallmentCount(1); // ย้ายการตั้งค่ามาหลังจากกำหนด formMasterList แล้ว
    } else {
      // สร้างรายการตามจำนวน installmentCount โดยไม่เคลียร์ datePay
      const newList = Array.from({ length: installmentCount }, (v, i) => {
        let amountPay = (grandTotal / installmentCount).toFixed(2);
        if (i === installmentCount - 1) {
          amountPay = (grandTotal - amountPay * (installmentCount - 1)).toFixed(
            2
          );
        }
        return {
          ...payMasterModel(),
          amountPay: formatCurrency(amountPay),
          docRemark1: "",
          docRemark2: "",
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        };
      });
      // ตั้งค่าให้กับ formMasterList โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0 และแทนที่ค่าใหม่
      newList[0] = currentList;
      setFormMasterList(newList);
      resetPaymentChannels();
    }

    setPaymentStatus(status); // ย้ายการตั้งค่ามาหลังจากกำหนด formMasterList แล้ว
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของจำนวนงวด
  const handleInstallmentCountChange = (value) => {
    if (isReadOnly) {
      return;
    }
    if (!/^\d*$/.test(value) || value === "" || value === "0") return 1; // ตรวจสอบว่าเป็นตัวเลขเท่านั้น

    const count = parseCurrency(value, 10); // แปลงค่าจาก string เป็น number

    if (count > 100) {
      getAlert(
        "FAILED",
        "คุณไม่สามารถกำหนดจำนวนงวดเกิน 100 งวดได้ กรุณากรอกค่าใหม่อีกครั้ง"
      );
      return 1;
    }

    // เก็บค่าของ formMasterList ที่มีอยู่เดิม
    const currentList = formMasterList[0]
      ? formMasterList[0]
      : payMasterModel();

    // เก็บค่า ap ข้อมูลไว้ก่อน
    const apData = {
      docDueDate: currentList.docDueDate, // ถ้าเป็นการสร้างใบจ่ายด้วยใบรับสินค้า
      apID: currentList.apID,
      apCode: currentList.apCode,
      arID: currentList.arID,
      arCode: currentList.arCode,
      apName:
        parseCurrency(docRefType) === 3
          ? currentList.arName
          : currentList.apName,
      apAdd1: currentList.AP_Add1,
      apAdd2: currentList.AP_Add2,
      apAdd3: currentList.AP_Add3,
      apProvince: currentList.AP_Province,
      apZipcode: currentList.AP_Zipcode,
      apTaxNo: currentList.AP_TaxNo,
    };

    // สร้าง default model ที่ใช้เป็นค่าเริ่มต้น
    const defaultModel = payMasterModel();

    // คำนวณ amountPay สำหรับแต่ละงวด
    const installmentAmount = (grandTotal / count).toFixed(2);
    let newList = Array.from({ length: count }, (v, i) => {
      let amountPay = installmentAmount;
      if (i === count - 1) {
        amountPay = (grandTotal - installmentAmount * (count - 1)).toFixed(2);
      }
      return {
        ...defaultModel,
        datePay: i === 0 ? currentList.datePay : null, // datePay จะไม่เป็น null เฉพาะรายการแรก
        amountPay: formatCurrency(parseCurrency(amountPay)),
        docRemark1: "", // เคลียร์ค่าเฉพาะที่ต้องการ
        docRemark2: "", // เคลียร์ค่าเฉพาะที่ต้องการ
        ...apData, // ตั้งค่า ap ข้อมูลกลับไป
      };
    });

    setInstallmentCount(count); // ตั้งค่าจำนวนงวด
    setFormMasterList(newList); // อัปเดต formMasterList
  };

  // SET REC
  const [showRecModal, setShowRecModal] = useState(false);
  const handleRecShow = () => setShowRecModal(true);
  const handleRecClose = () => setShowRecModal(false);
  const onRowSelectRec = async (recSelected) => {
    try {
      const hasVat = recSelected.find((rec) => rec.IsVat === 1);
      const hasNoVat = recSelected.find((rec) => rec.IsVat === 0);

      if (hasVat && hasNoVat) {
        getAlert(
          "FAILED",
          "ไม่สามารถเลือกใบรับสินค้าที่มี VAT และไม่มี VAT ร่วมกันได้"
        );
        return;
      }

      // ค้นหาข้อมูลที่ตรงกับ recSelected.Rec_No ใน REC_H และ AP_ID ใน apDataList
      const [getAllRecH, getAllItem] = await Promise.all([
        getDataWithComp("API_0301_REC_H", "ORDER BY Rec_No DESC"),
        getDataWithComp("API_0302_REC_D", "ORDER BY Line ASC"),
      ]);

      // เดิมเคยบังคับให้เหลือเพียงใบที่ค้างจ่ายใบเดียว ทำให้เลือกหลายใบไม่ได้
      // ปรับใหม่: ไม่บังคับลดเหลือใบเดียวอีกต่อไป ปล่อยให้ recSelected เป็นหลายใบตามที่ผู้ใช้เลือก

      // ใช้ Set เพื่อหลีกเลี่ยงการค้นหาซ้ำ
      const recNoSet = new Set(recSelected.map((rec) => rec.Rec_No));
      const recNoArray = Array.from(recNoSet);

      const createNewRow = (index, itemSelected) => {
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;

        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal;
        } else {
          itemTotal -= itemDiscount;
        }

        return {
          ...payDetailModel(index + 1),
          recDtId: itemSelected.DT_Id,
          recId: itemSelected.Rec_Id,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          recNo: itemSelected.Rec_No,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty, true),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal: formatCurrency(itemTotal, true),
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          itemDesc: null,
        };
      };

      // สร้างฟังก์ชันสำหรับการดึงข้อมูลของแต่ละ Rec_No
      const fetchDetailsForRecNo = async (recNo) => {
        // recNo may actually be a Rec_No (string) or a Rec_Id (numeric/string with spaces).
        const normalized = recNo === undefined || recNo === null ? "" : String(recNo).trim();

        const filterItem = getAllItem.filter(
          (item) =>
            String(item.Rec_No) === normalized || String(item.Rec_Id) === normalized
        );

        const fromViewRecH = getAllRecH.find(
          (po) => String(po.Rec_No) === normalized || String(po.Rec_Id) === normalized
        );

        if (!fromViewRecH) {
          throw new Error(`ไม่พบข้อมูล REC_H สำหรับ Rec_No/Rec_Id: ${recNo}`);
        }

        // การสร้างรายละเอียด
        if (filterItem.length > 0) {
          const newFormDetails = filterItem.map((item, index) =>
            createNewRow(index, item)
          );
          return { fromViewRecH, newFormDetails };
        } else {
          throw new Error(`ไม่พบข้อมูล REC_D สำหรับ Rec_No/Rec_Id: ${recNo}`);
        }
      };

      // ดึงข้อมูลสำหรับ Rec_No ทั้งหมดใน recSelected
      const results = await Promise.all(
        recNoArray.map((recNo) => fetchDetailsForRecNo(recNo))
      );

      // รวมข้อมูลทั้งหมด
      const allDetails = results.flatMap((result) => result.newFormDetails);

      // // ดึงข้อมูล PO สำหรับการคำนวณส่วนลด
      const [getViewPoH] = await Promise.all([
        getDataWithComp("API_0201_PO_H", ""),
      ]);

      const calculateDiscountAndVat = (rec, isUpdateMode = false) => {
        const relatedPoH = getViewPoH.find((po) => po.Doc_ID === rec?.Ref_DocID);

        if (relatedPoH) {
          // คำนวณส่วนลด
          if (relatedPoH.IsVat === 1) {
            setIsVatChecked(true);
          }
        }
      };

      recSelected.forEach((rec) => {
        calculateDiscountAndVat(rec, mode === "U");
      });

      // ตั้งค่า formDetailList
      setFormDetailList(allDetails);

      // หาวันที่ใบรับที่น้อยที่สุดจาก recSelected
      const minRecDate = Math.min(
        ...recSelected.map((rec) => new Date(rec.Rec_Date).getTime())
      );

      if (mode === "I") {
        // อัปเดต formMasterList สำหรับทุกรายการ
        setFormMasterList((prevState) =>
          prevState.map((item) => ({
            ...item,
            refDoc: "ใบรับสินค้าจำนวน " + recSelected.length + " ใบ",
            // Use date-only strings to prevent implicit timezone (+7h)
            payDate: moment().format('YYYY-MM-DD'),
            docDueDate: moment(minRecDate).format('YYYY-MM-DD'),
            transportType: results[0].fromViewRecH.Transport_Type,
            apID: results[0].fromViewRecH.AP_ID,
            apCode: results[0].fromViewRecH.AP_Code,
            apName: results[0].fromViewRecH.AP_Name,
            apAdd1: results[0].fromViewRecH.AP_Add1,
            apAdd2: results[0].fromViewRecH.AP_Add2,
            apAdd3: results[0].fromViewRecH.AP_Add3,
            apProvince: results[0].fromViewRecH.AP_Province,
            apZipcode: results[0].fromViewRecH.AP_Zipcode,
            apTaxNo: results[0].fromViewRecH.AP_TaxNo,
            createdByName: window.localStorage.getItem("name"),
            createdDate: getCreateDateTime(),
            updateDate: results[0].fromViewRecH.Update_By_Name,
            updateByName: results[0].fromViewRecH.Update_Date,
            discountValueType: results[0].fromViewRecH.Discount_Value_Type,
            discountValue: results[0].fromViewRecH.Discount_Value,
          }))
        );

        try {
          const dvType = results[0].fromViewRecH.Discount_Value_Type;
          const dvValue = results[0].fromViewRecH.Discount_Value;
          if (!isNaN(parseInt(dvType))) {
            setSelectedDiscountValueType(String(dvType));
          }
        } catch (err) {
          // ignore
        }
        let totalPrice = 0;
        let receiptDiscount = 0;
        let receiptVatAmount = 0;
        let uniquePOs = new Set();

        // คำนวณส่วนลดจาก REC_H แทนที่จะใช้จาก PO
        for (const result of results) {
          const recH = result.fromViewRecH;

          // รวมยอดรวมจาก Detail
          for (const detail of result.newFormDetails) {
            totalPrice += parseCurrency(detail.itemTotal) || 0;
          }

          // คำนวณส่วนลดจาก REC_H
          const recDiscountValue = parseCurrency(recH.Discount_Value) || 0;
          const recDiscountType = parseInt(recH.Discount_Value_Type) || 1;

          let discountAmount = 0;
          if (recDiscountType === 1) {
            // ลดเป็นจำนวนเงิน (บาท)
            discountAmount = recDiscountValue;
          } else if (recDiscountType === 2) {
            // ลดเป็นเปอร์เซ็นต์
            // คำนวณจากยอดรวมของ REC นี้
            const recTotal = result.newFormDetails.reduce((sum, detail) =>
              sum + (parseCurrency(detail.itemTotal) || 0), 0
            );
            discountAmount = (recTotal * recDiscountValue) / 100;
          }

          receiptDiscount += discountAmount;

          // คำนวณ VAT
          if (recH.IsVat === 1) {
            setIsVatChecked(true);
            // หา VAT จาก Detail ของ REC นี้
            const recTotal = result.newFormDetails.reduce((sum, detail) =>
              sum + (parseCurrency(detail.itemTotal) || 0), 0
            );
            receiptVatAmount += (recTotal - discountAmount) * 0.07;
          }
        }

        // ค้นหาไฟล์ที่เกี่ยวข้อง (รวมจากหลายใบรับสินค้า แทนการเขียนทับ)
        const accumulatedRecFiles = [];
        for (const recSelect of recSelected) {
          if (recSelect && recSelect.Rec_Id) {
            const image = await getDataWithComp(
              "Upload_File_List",
              `AND DocCode_ID = 3 AND Doc_ID = ${recSelect.Rec_Id}`
            );
            if (Array.isArray(image) && image.length > 0) {
              accumulatedRecFiles.push(...image);
            }
          }
        }

        // ลบรายการซ้ำตาม File_Url หรือ F_Id แล้วตั้งค่า state ครั้งเดียว
        if (accumulatedRecFiles.length > 0) {
          const map = new Map();
          for (const f of accumulatedRecFiles) {
            const key = f.File_Url || f.F_Id || JSON.stringify(f);
            if (!map.has(key)) map.set(key, f);
          }
          const merged = Array.from(map.values());
          setSelectedRecFiles(merged);
        } else {
          setSelectedRecFiles([]);
        }

        // อัปเดตค่าทั้งหมด
        setTotalPrice(totalPrice);
        setReceiptDiscount(receiptDiscount);
        setVatAmount(receiptVatAmount);

        // อัปเดตส่วนลดไปที่ footer (เป็นจำนวนเงิน)
        try {
          if (!isNaN(parseFloat(receiptDiscount)) && parseFloat(receiptDiscount) > 0) {
            setSelectedDiscountValueType("1");
            setFormMasterList((prev) => {
              if (!prev || prev.length === 0) return prev;
              const updated = prev.map((item) => ({
                ...item,
                discountValue: formatCurrency(parseCurrency(receiptDiscount)),
                discountValueType: 1,
              }));
              return updated;
            });
          } else {
            setFormMasterList((prev) => {
              if (!prev || prev.length === 0) return prev;
              const updated = prev.map((item) => ({
                ...item,
                discountValue: formatCurrency(0),
                discountValueType: item.discountValueType || 1,
              }));
              return updated;
            });
          }
        } catch (err) {
          // ignore any formatting errors
        }
      }

      // ทำการเอาไปรับไปหาใบ PO ที่เคยจ่ายล่วงหน้าไปแล้ว
      const payDetailList = await getDataWithComp(
        "API_0402_PAY_D",
        `AND Pay_Type = 4 AND PayStatus_Name = 'จ่ายแล้ว' AND Rec_Id = ${recSelected[0]?.Ref_DocID}`
      );
      if (payDetailList && payDetailList.length > 0) {
        if (parseCurrency(payDetailList[0].Total_Pay_Per) > 0) {
          setPayBefore(payDetailList[0].Total_Pay_Per);
          setIsPayBefore(true);
          CalculationTotalDis({
            target: {
              value: formatCurrency(payDetailList[0].Total_Pay_Per),
            },
          });
        }
      }

      handleRecClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const onConfirmRecSelection = async (recSelected) => {
    try {
      if (!recSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบรับสินค้า");
        return;
      }

      handleRecClose();

      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList([payMasterModel()]);
      setFormDetailList([]);
      setPaymentStatus("oneTime");
      setInstallmentCount(1);
      resetPaymentChannels();

      onRowSelectRec(recSelected);
    } catch (error) {
      console.error("Error in confirming receipt selection:", error);
      getAlert("FAILED", "เกิดข้อผิดพลาดในการเลือกใบรับสินค้า");
    }
  };

  // SET PO
  const [showPoModal, setShowPoModal] = useState(false);
  const handlePoShow = () => setShowPoModal(true);
  const handlePoClose = () => setShowPoModal(false);
  const onRowSelectPo = async (poSelected) => {
    if (Array.isArray(poSelected)) {
      poSelected = poSelected[0];
    }
    if (!poSelected || typeof poSelected !== "object") return;
    try {
      const allPoHeaders = await getDataWithComp("API_0201_PO_H", "ORDER BY Doc_No DESC");
      const allPoDetails = await getDataWithComp("API_0202_PO_D", "AND Item_Status = 1 ORDER BY Line ASC");
      const poHeader = allPoHeaders.find(po => po.Doc_No === poSelected.Doc_No);
      if (!poHeader) throw new Error("ไม่พบข้อมูลหัวเอกสารใบสั่งซื้อ");

      const poDetails = allPoDetails.filter(
        item => item.Doc_No === poSelected.Doc_No
      );

      let totalPrice = 0;
      let receiptDiscount = 0;
      let vatAmount = 0;
      let detailsRows = [];

      poDetails.forEach((item, idx) => {
        let itemQty = parseCurrency(item.Item_REC_Balance) || 0;
        let itemPriceUnit = parseCurrency(item.Item_Price_Unit) || 0;
        let itemDiscount = parseCurrency(item.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;
        if (item.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal;
        } else {
          itemTotal -= itemDiscount;
        }
        totalPrice += item.Item_Total;
        const detail = {
          ...payDetailModel(idx + 1),
          recDtId: item.DT_Id,
          recId: item.Doc_ID,
          line: item.Line,
          itemId: item.Item_Id,
          itemCode: item.Item_Code,
          itemName: item.Item_Name,
          itemQty: formatCurrency(itemQty, true) || 0,
          itemRecBalance: formatCurrency(item.Item_REC_Balance, true) || 0,
          itemUnit: item.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType: String(item.Item_DisType),
          itemTotal: formatCurrency(itemTotal, true),
          itemGroup: item.Item_Group,
          itemStatus: item.Item_Status,
          docRemark2: poHeader.Doc_Remark2,
          docType: poHeader.Doc_Type,
          docFor: poHeader.Doc_For,
          transportType: poHeader.Transport_Type,
          discountValue: poHeader.Discount_Value,
          discountValueType: poHeader.Discount_Value_Type,
          creditTerm: poHeader.CreditTerm,
          apID: poHeader.AP_ID,
          apCode: poHeader.AP_Code,
          apName: poHeader.AP_Name,
          apAdd1: poHeader.AP_Add1,
          apAdd2: poHeader.AP_Add2,
          apAdd3: poHeader.AP_Add3,
          apProvince: poHeader.AP_Province,
          apZipcode: poHeader.AP_Zipcode,
          apTaxNo: poHeader.AP_TaxNo,
          createdByName: window.localStorage.getItem("emp_name"),
          createdDate: getCreateDateTime(),
          updateDate: poHeader.Update_Date,
          updateByName: poHeader.Update_By_Name,
        };
        detailsRows.push(detail);
      });

      setFormDetailList(detailsRows);
      setTotalPrice(totalPrice);
      setReceiptDiscount(receiptDiscount);

      const computedSubFinal = totalPrice - (receiptDiscount || 0);

      // คำนวณ VAT ทันที (ไม่รอ useEffect)
      const poHasVat = parseInt(poHeader.IsVat, 10) === 1;
      const computedVatAmount = poHasVat ? computedSubFinal * 0.07 : 0;

      const computedGrandTotal = computedSubFinal + computedVatAmount - (totalWT || 0);
      const computedFinalTotal = computedGrandTotal - (disTotal || 0);

      setSubFinal(computedSubFinal);
      setVatAmount(computedVatAmount);
      setGrandTotal(computedGrandTotal);
      setFinalTotal(computedFinalTotal);

      setIsVatChecked(poHasVat);

      if (!isNaN(poHeader.Discount_Value_Type)) {
        setSelectedDiscountValueType(poHeader.Discount_Value_Type.toString());
      }

      try {
        const currentMaster = formMasterList[0] ? formMasterList[0] : payMasterModel();
        setFormMasterList([
          {
            ...currentMaster,
            apID: poHeader.AP_ID,
            apCode: poHeader.AP_Code,
            apName: poHeader.AP_Name,
            apAdd1: poHeader.AP_Add1,
            apAdd2: poHeader.AP_Add2,
            apAdd3: poHeader.AP_Add3,
            apProvince: poHeader.AP_Province,
            apZipcode: poHeader.AP_Zipcode,
            apTaxNo: poHeader.AP_TaxNo,
            isVat: parseInt(poHeader.IsVat, 10),
            discountValue: poHeader.Discount_Value,
            amountPay: formatCurrency(computedFinalTotal),
          },
        ]);
      } catch (err) {
        console.warn("Failed to update master with PO header values:", err);
      }

      handlePoClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      // เก็บค่าของ formMasterList ที่มีอยู่เดิม
      const currentList = formMasterList[0]
        ? formMasterList[0]
        : payMasterModel();

      // เก็บค่า ap ข้อมูลไว้ก่อน
      const apData = {
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
      };

      // ตั้งค่าให้กับรายการเดียว โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0
      setFormMasterList([
        {
          ...currentList,
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        },
      ]);

      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      setFormDetailList([
        ...formDetailList,
        ...itemsSelected.map((itemSelected) => {
          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemDesc: null,
          };
        }),
      ]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    if (isReadOnly) {
      return;
    }
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (docRefType !== "4") {
      const total = formDetailList.reduce(
        (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
        0
      );

      // ตรวจสอบชนิดของ amountPay และแปลงให้เหมาะสม
      let amountPay = formMasterList[0]?.amountPay; // ใช้ Optional Chaining เพื่อป้องกันข้อผิดพลาดกรณี formMasterList[0] ไม่มีค่า
      if (typeof amountPay === "string") {
        amountPay = parseCurrency(amountPay.replace(/,/g, "")) || 0;
      } else if (typeof amountPay === "number") {
        amountPay = amountPay || 0;
      } else {
        amountPay = 0; // ค่าเริ่มต้นในกรณีที่ไม่ใช่ string หรือ number
      }

      setTotalPrice(total);
    }
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList[0].discountValue || 0);
    let receiptDiscount = 0;
    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }
    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList[0].discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal) (ไม่ได้ใช้)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    if (docRefType === "2") {
      const vat = isVatChecked ? subFinal * 0.07 : 0;
      setVatAmount(vat);
    } else if (docRefType === "1") {
      const vat = isVatChecked ? subFinal * 0.07 : 0;
      setVatAmount(vat);
    }
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const calculatedGrandTotal = subFinal + vatAmount - totalWT;
    const calculatedFinalTotal = calculatedGrandTotal - disTotal;

    setGrandTotal(calculatedGrandTotal);
    setFinalTotal(calculatedFinalTotal);

    if (
      (parseCurrency(docRefType) === 1 && mode !== "U") ||
      (parseCurrency(docRefType) === 2 && formMasterList[0]?.payStatus === 1) ||
      (parseCurrency(docRefType) === 3 && mode !== "U")
    ) {
      if (mode === "I") {
        const formattedValue = formatCurrency(calculatedFinalTotal);
        setFormMasterList((prevList) => {
          const updatedList = [...prevList];
          if (updatedList.length > 0) {
            updatedList[0].amountPay = formattedValue;
          }
          return updatedList;
        });
      }
    }

  }, [subFinal, vatAmount, totalWT, disTotal]);

  useEffect(() => {
    if (docRefType !== "4") {
      if (formMasterList[0].payStatus === 1) {
        setOutstandingBalance(FinalTotal);
      } else {
        setOutstandingBalance(0.0);
      }
    }
  }, [grandTotal, outstandingBalance, FinalTotal]);

  const [showModalDatePicker, setShowModalDatePicker] = useState(false);
  const [selectedDateIndex, setSelectedDateIndex] = useState(null);

  const openModalDatePicker = (index) => {
    setSelectedDateIndex(index);
    setShowModalDatePicker(true);
  };

  const closeModalDatePicker = () => setShowModalDatePicker(false);

  useEffect(() => {
    if (docRefType !== "4") {
      let discountValue = parseCurrency(formMasterList[0]?.discountValue || 0);
      let calculatedDiscount = 0;

      if (selectedDiscountValueType === "2") {
        // ส่วนลดเป็นเปอร์เซ็นต์
        calculatedDiscount = (totalPrice * discountValue) / 100;
      } else if (selectedDiscountValueType === "1") {
        // ส่วนลดเป็นจำนวนเงิน
        calculatedDiscount = discountValue;
      }

      // ตรวจสอบค่าก่อนตั้งค่า
      if (!isNaN(calculatedDiscount) && calculatedDiscount !== receiptDiscount) {
        setReceiptDiscount(calculatedDiscount);
      }
    }
  }, [totalPrice, formMasterList[0]?.discountValue, selectedDiscountValueType]);

  const [showWTModal, setShowWTModal] = useState(false);
  const handleWTClose = () => setShowWTModal(false);
  const CalculationTotalWT = (event) => {
    const value = event.target.value.replace(/,/g, "");
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = parseFloat(value) || 0;
      setTotalWT(numericValue);
      setInputValueTotalWT(value);
    }
  };

  const handleBlurTotalWT = () => {
    const numericValue =
      parseCurrency(inputValueTotalWT.replace(/,/g, "")) || 0;
    setTotalWT(numericValue);
    setInputValueTotalWT(
      numericValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    ); // ใส่ , คั่นหลักพัน
  };

  const handleFocusTotalWT = () => {
    setInputValueTotalWT(String(totalWT).replace(/,/g, ""));
  };

  const setdetailsTotalWT = () => {
    if (taxData.length === 0) {
      setTaxData([
        {
          id: 1,
          type: 5,
          percent: 3.0,
          date: currentDate,
          amount: 0.0,
          tax: 0.0,
          remark: "",
        },
        {
          id: 2,
          type: 6,
          percent: 3.0,
          date: currentDate,
          amount: 0.0,
          tax: 0.0,
          remark: "",
        },
      ]);
    }
    setShowWTModal(true);
  };

  const CalculationTotalDis = (event) => {
    const value = event.target.value.replace(/,/g, "");
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = parseCurrency(value) || 0;
      setDisTotal(numericValue);
      setInputValuedisTotal(value);
    }
  };

  const handleBlurTotalDis = () => {
    const numericValue =
      parseCurrency(inputValuedisTotal.replace(/,/g, "")) || 0;
    setDisTotal(numericValue);
    setInputValuedisTotal(
      numericValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    ); // ใส่ , คั่นหลักพัน
  };

  const handleFocusTotalDis = () => {
    setInputValuedisTotal(String(disTotal).replace(/,/g, ""));
  };

  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleApproveAction = () => {
    if (!showApprovalButtons) {
      return;
    }
    if (typeof onApprove === "function") {
      onApprove({
        master: masterRecord,
        details: formDetailList,
        files: selectedFiles,
      });
    }
  };

  const handleRejectAction = () => {
    if (!showApprovalButtons) {
      return;
    }
    if (typeof onReject === "function") {
      onReject({
        master: masterRecord,
        details: formDetailList,
        files: selectedFiles,
      });
    }
  };

  return (
    <>
      <Topbar
        breadcrumbs={[
          { label: "จัดซื้อสินค้า", link: listUrl },
          { label: name, link: listUrl },
          { label: mode === "U" ? "เรียกดู" + name : "สร้าง" + name },
        ]}
      />
      <CreditorQuickCreateModal
        show={showCreditorModal}
        onClose={() => setShowCreditorModal(false)}
        onSuccess={handleCreditorSuccess}
      />
      <Breadcrumbs
        page={maxPayNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherTypeName={statusPaidTypeName}
        otherTypeColour={statusPaidTypeColour}
        items={[
          { name: "จัดซื้อสินค้า", url: listUrl },
          { name: name, url: listUrl },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => {
          const status = formMasterList?.[0]?.Pay_Status ?? formMasterList?.[0]?.payStatus ?? formMasterList?.[0]?.PayStatus;
          if (String(status) === '13') return;
          getReport("pay", formMasterList[0].payNo);
        }}
        mode={mode}
        openUploadAttach={openUploadAttach}
        setOpenUploadAttach={setOpenUploadAttach}
        showViewAttachModal={showViewAttachModal}
        setShowViewAttachModal={setShowViewAttachModal}
        selectedFiles={selectedFiles}
        selectedRecFiles={selectedRecFiles}
        setSelectedFiles={setSelectedFiles}
        handleRemoveImage={handleRemoveImage}
        handleInputFileChange={handleInputFileChange}
        handleBeforeUploadAttach={handleBeforeUploadAttach}
        urlImg={formMasterList[0].docPaidPic}
        handleUploadSlip={handleUploadSlip}
        base64Image={base64Image}
        setBase64Image={setBase64Image}
      />
      <fieldset
        disabled={isReadOnly}
        style={{ border: "none", padding: 0, margin: 0 }}
      >
        <div
          className="hidden-scrollbar"
          style={{ maxHeight: "auto", overflowY: "auto" }}
        >
          <div className="row mt-1 purchase-form-row">
            <div className="col-12 col-md-6 col-lg-4">
              <DatePicker
                label="วันที่เอกสาร"
                name="payDate"
                value={formMasterList[0]?.payDate}
                onChange={(date) =>
                  handleChangeDateMasterList(date, "payDate", 0)
                }
                disabled={isReadOnly || mode === "U"}
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>ผู้ขาย</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apCode"
                    value={
                      (formMasterList[0]?.apCode || "") +
                      " " +
                      (formMasterList[0]?.apName || "")
                    }
                    onChange={handleChangeMasterList}
                    disabled={true}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleApShow}
                    disabled={
                      docRefType === "1" || docRefType === "3" || docRefType === "4" || mode === "U"
                        ? true
                        : false
                    }
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <button
                    className="btn btn-outline-success"
                    onClick={() => setShowCreditorModal(true)}
                    type="button"
                    disabled={
                      docRefType === "1" || docRefType === "3" || docRefType === "4" || mode === "U"
                        ? true
                        : false
                    }
                    title="สร้างผู้ขายใหม่"
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              <ApModal
                showApModal={showApModal}
                handleApClose={handleApClose}
                apDataList={apDataList}
                onRowSelectAp={onRowSelectAp}
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>วันที่สร้างเอกสาร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="createdDate"
                  value={formatThaiDayMonthShortYear(formMasterList[0]?.createdDate)}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1 purchase-form-row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label className="me-2">เอกสารอ้างอิง</label>
                <select
                  name="payType"
                  value={formMasterList[0]?.docRefType}
                  className="form-select form-control input-spacing"
                  onChange={(e) => handleChangePayType(e.target.value)}
                  disabled={isReadOnly || mode === "U"}
                >
                  <option value="1">จ่ายตามใบรับสินค้า</option>
                  <option value="2">จ่ายเฉพาะรายการ</option>
                  <option value="3">จ่ายตามใบมัดจำ</option>
                  <option value="4">จ่ายตามใบสั่งซื้อ (ล่วงหน้า)</option>
                  <option value="5" disabled>
                    จ่ายตามใบแจ้งซ่อม
                  </option>
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>ที่อยู่</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apAdd1"
                  value={formMasterList[0]?.apAdd1 || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>ผู้สร้างเอกสาร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="createdByName"
                  value={formMasterList[0]?.createdByName || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1 purchase-form-row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>อ้างอิงเอกสาร</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="refDoc"
                    value={formMasterList[0]?.refDoc || ""}
                    onChange={handleChangeMasterList}
                    disabled={true}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleRecShow}
                    hidden={docRefType === "1" ? false : true}
                    disabled={mode === "U"}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handlePoShow}
                    hidden={docRefType === "4" ? false : true}
                    disabled={mode === "U"}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                <RecModal
                  showRecModal={showRecModal}
                  handleRecClose={handleRecClose}
                  recDataList={recDataList}
                  onConfirmRecSelection={onConfirmRecSelection}
                />
                <PoModal
                  showPoModal={showPoModal}
                  handlePoClose={handlePoClose}
                  poDataList={poDataList}
                  onRowSelectPo={onRowSelectPo}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label></label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={
                    (formMasterList[0]?.apAdd2 || "") +
                    " " +
                    (formMasterList[0]?.apAdd3 || "")
                  }
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>วันที่แก้ไขล่าสุด</label>
                <input
                  // type="date"
                  type="text"
                  className="form-control input-spacing"
                  name="updateDate"
                  value={formatThaiDayMonthShortYear(formMasterList[0]?.updateDate) || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1 purchase-form-row">
            <div className="col-12 col-md-6 col-lg-4">
              <DatePicker
                label="กำหนดจ่าย"
                name="docDueDate"
                value={formMasterList[0]?.docDueDate}
                onChange={(date) =>
                  handleChangeDateMasterList(date, "docDueDate", 0)
                }
                disabled={isReadOnly || isPaymentStatusDisabled}
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label></label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={
                    (formMasterList[0]?.apProvince || "") +
                    " " +
                    (formMasterList[0]?.apZipcode || "")
                  }
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>ผู้แก้ไขเอกสาร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="updateByName"
                  value={formMasterList[0]?.updateByName || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1 purchase-form-row">
            <div className="col-12 col-md-6 col-lg-4">
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label></label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList[0]?.apTaxNo || ""}
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>วันที่อนุมัติ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="approvedDate"
                  value={formMasterList[0]?.approvedDate || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1 purchase-form-row">
            <div className="col-12 col-md-6 col-lg-4">
              {/* <div className="d-flex align-items-center">
              <label>วัตถุประสงค์</label>
              <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMasterList}
                disabled={true}
                className="form-select form-control input-spacing"
              >
                {docRefType === "2" && (
                  <>
                    <option value="1">ซื้อมาเพื่อใช้</option>
                    <option value="2">ซื้อมาเพื่อขาย</option>
                  </>
                )}
              </select>
            </div> */}
            </div>
            <div className="col-12 col-md-6 col-lg-4"></div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>ผู้อนุมัติเอกสาร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="approvedByName"
                  value={formMasterList[0]?.approvedByName || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mt-1 purchase-form-row">
            <div className="col-12 col-md-6 col-lg-4"></div>
            <div className="col-12 col-md-6 col-lg-4"></div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="d-flex align-items-center">
                <label>หมายเหตุอนุมัติ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="approvedMemo"
                  value={formMasterList[0]?.approvedMemo || ""}
                  onChange={(e) => handleChangeMasterList(0, "approvedMemo", e.target.value)}
                  disabled={!showApprovalButtons || !isPendingApproval}
                />
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <button
                        style={{ cursor: "pointer", color: "#E13F57" }}
                        className={`nav-link ${activeTab === "summary" ? "active" : ""
                          }`}
                        onClick={() => handleTabChange("summary")}
                      >
                        ยอดรวม
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        style={{ cursor: "pointer", color: "#E13F57" }}
                        className={`nav-link ${activeTab === "details" ? "active" : ""
                          }`}
                        onClick={() => handleTabChange("details")}
                      >
                        รายละเอียดสินค้า
                      </button>
                    </li>
                  </ul>
                </div>
                {activeTab === "summary" ? (
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-4">
                            <div className="card h-100">
                              <div className="card-body">
                                <h4 className="card-title">ยอดท้ายบิล</h4>
                                <div className="mt-3">
                                  <div className="row g-2 align-items-center">
                                    <div className="col-5"><label className="col-form-label">รวมราคา</label></div>
                                    <div className="col-7"><input type="text" className="form-control text-end input-spacing" value={formatCurrency(totalPrice || 0)} disabled /></div>
                                  </div>
                                  <div className="row g-2 align-items-center mt-2">
                                    <div className="col-5"><label className="col-form-label">รวมส่วนลด</label></div>
                                    <div className="col-7"><input type="text" className="form-control text-end input-spacing" value={formatCurrency(receiptDiscount)} disabled /></div>
                                  </div>
                                  <hr className="my-3" />
                                  <div className="row g-2 align-items-center">
                                    <div className="col-5 d-flex align-items-center">
                                      {docRefType === "2" && (
                                        <input type="checkbox" className="me-2" checked={isVatChecked} onChange={handleVatChange} disabled={formMasterList[0]?.payStatus === 2} />
                                      )}
                                      <label className="mb-0">VAT</label>
                                    </div>
                                    <div className="col-7"><input type="text" className="form-control text-end input-spacing" value={formatCurrency(truncateTo2Decimals(roundTo2With3rdDigitRule(vatAmount) || 0))} disabled /></div>
                                  </div>
                                  <hr className="my-3" />
                                  <div className="row g-2 align-items-center">
                                    <div className="col-5"><label className="col-form-label"><strong>หัก ณ ที่ จ่าย</strong></label></div>
                                    <div className="col-7">
                                      <div className="input-group">
                                        <input type="text" className="form-control text-end input-spacing fw-bold" value={inputValueTotalWT} onChange={CalculationTotalWT} onBlur={handleBlurTotalWT} onFocus={handleFocusTotalWT} disabled={(formMasterList.length > 0 && formMasterList[0]?.payStatus === 1) ? (docRefType === "4" ? true : false) : true} />
                                        <button onClick={() => setdetailsTotalWT()} className="btn text-white" style={{ backgroundColor: '#E13F57' }} type="button" disabled={docRefType === "4"}>+</button>
                                      </div>
                                      {taxData.length > 0 && taxData[0]?.amount !== 0.0 && taxData.length !== 0 ? (
                                        <select className="form-select mt-2" value={selectedOption} disabled>
                                          <option value={1}>(1) ภ.ง.ด.1ก.</option>
                                          <option value={2}>(2) ภ.ง.ด.1ก.พิเศษ</option>
                                          <option value={3}>(3) ภ.ง.ด.2</option>
                                          <option value={4}>(4) ภ.ง.ด.3</option>
                                          <option value={5}>(5) ภ.ง.ด.2ก.</option>
                                          <option value={6}>(6) ภ.ง.ด.3ก.</option>
                                          <option value={7}>(7) ภ.ง.ด.53</option>
                                        </select>
                                      ) : null}
                                      <WtaxModal
                                        showWTModal={showWTModal}
                                        handleWTClose={handleWTClose}
                                        apDataList={apDataList}
                                        setTotalWT={setTotalWT}
                                        setInputValueTotalWT={setInputValueTotalWT}
                                        selectedOption={selectedOption}
                                        setSelectedOption={setSelectedOption}
                                        taxData={taxData}
                                        setTaxData={setTaxData}
                                        setTaxtotalAmount={setTaxtotalAmount}
                                        formMasterList={formMasterList}
                                        setFormMasterList={setFormMasterList}
                                        docRef={docRef}
                                        setDocRef={setDocRef}
                                        Ref_PAY_ID={Ref_PAY_ID}
                                        setRef_PAY_ID={setRef_PAY_ID}
                                      />
                                    </div>
                                  </div>
                                  <div className="row g-2 align-items-center mt-3">
                                    <div className="col-5"><label className="col-form-label"><strong>รวมยอด</strong></label></div>
                                    <div className="col-7"><input type="text" className="form-control text-end input-spacing fw-bold text-danger" value={formatCurrency(grandTotal || 0)} disabled /></div>
                                  </div>
                                  <div className="row g-2 align-items-center mt-2">
                                    <div className="col-5"><label className="col-form-label"><strong>ส่วนลดท้ายใบจ่าย</strong></label></div>
                                    <div className="col-7"><input type="text" className="form-control text-end input-spacing fw-bold" value={inputValuedisTotal} onChange={CalculationTotalDis} onBlur={handleBlurTotalDis} onFocus={handleFocusTotalDis} disabled={formMasterList[0].payStatus !== 1 || (docRefType === "4")} /></div>
                                  </div>
                                  <div className="row g-2 align-items-center mt-2">
                                    <div className="col-5"><label className="col-form-label"><strong>รวมจ่ายสุทธิ</strong></label></div>
                                    <div className="col-7"><input type="text" className="form-control text-end input-spacing fw-bold text-danger" value={formatCurrency(FinalTotal || 0)} disabled /></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-8">
                            <div>
                              <div className="row mt-3">
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="card">
                                        <div className="card-header">
                                          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
                                            <div className="d-flex flex-column">
                                              <div className="d-flex align-items-center flex-wrap gap-2">
                                                <h4 className="card-title mb-0 me-1">ตารางจ่าย</h4>
                                                <div className="btn-group" role="group" aria-label="สถานะการจ่าย">
                                                  <input
                                                    type="radio"
                                                    className="btn-check"
                                                    name="paymentStatus"
                                                    id="payOneTime"
                                                    value="oneTime"
                                                    checked={paymentStatus === "oneTime"}
                                                    onChange={() => handlePaymentStatusChange("oneTime")}
                                                    disabled={isPaymentStatusDisabled}
                                                  />
                                                  <label
                                                    className={`btn btn-sm ${paymentStatus === 'oneTime' ? 'btn-danger text-white' : 'btn-outline-secondary'}${isPaymentStatusDisabled ? ' disabled' : ''}`}
                                                    htmlFor="payOneTime"
                                                  >
                                                    จ่ายครั้งเดียว
                                                  </label>

                                                  <input
                                                    type="radio"
                                                    className="btn-check"
                                                    name="paymentStatus"
                                                    id="payInstallment"
                                                    value="installment"
                                                    checked={paymentStatus === "installment"}
                                                    onChange={() => handlePaymentStatusChange("installment")}
                                                    disabled={isPaymentStatusDisabled}
                                                  />
                                                  <label
                                                    className={`btn btn-sm ${paymentStatus === 'installment' ? 'btn-danger text-white' : 'btn-outline-secondary'}${isPaymentStatusDisabled ? ' disabled' : ''}`}
                                                    htmlFor="payInstallment"
                                                  >
                                                    จ่ายเป็นงวด
                                                  </label>
                                                </div>
                                              </div>
                                              {isPayBefore && (
                                                <p className="mb-0" style={{ color: 'red', fontWeight: 'bold', marginTop: '8px' }}>
                                                  *** มีการชำระเงินล่วงหน้าไปแล้ว เป็นจำนวนเงิน {formatCurrency(payBefore)} บาท ****
                                                </p>
                                              )}
                                            </div>
                                            <div className="d-flex align-items-center">
                                              {paymentStatus === "installment" && (
                                                <div className="input-group input-group-sm" style={{ width: 170 }}>
                                                  <span className="input-group-text">จำนวนงวด</span>
                                                  <input
                                                    type="number"
                                                    min={1}
                                                    className="form-control text-end"
                                                    value={installmentCount}
                                                    onChange={(e) => handleInstallmentCountChange(e.target.value)}
                                                    disabled={isPaymentStatusDisabled}
                                                  />
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="card-body">
                                          <div
                                            className="table-responsive"
                                            style={{
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                              zIndex: "1",
                                            }}
                                          >
                                            <table className="table table-striped table-hover">
                                              <thead className="thead-dark">
                                                <tr>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "2%" }}
                                                  >
                                                    #
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "18%" }}
                                                  >
                                                    วันที่จ่าย
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "18%" }}
                                                  >
                                                    จำนวนเงิน
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "31%" }}
                                                  >
                                                    รายละเอียดเอกสาร
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "31%" }}
                                                  >
                                                    หมายเหตุธุรการ
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {formMasterList.map(
                                                  (item, index) => (
                                                    <tr key={index + 1}>
                                                      <td className="text-center">
                                                        {index + 1}
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control text-center"
                                                          value={
                                                            item.datePay
                                                              ? formatDate(item.datePay)
                                                              : "เลือกวันที่"
                                                          }
                                                          onClick={() =>
                                                            openModalDatePicker(
                                                              index
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              .payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                      <td className="text-end">
                                                        <input
                                                          type="text"
                                                          className="form-control text-end input-spacing"
                                                          value={formatCurrency(
                                                            item.amountPay || 0
                                                          )}
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "amountPay",
                                                              e.target.value
                                                            )
                                                          }
                                                          onFocus={(e) =>
                                                            handleFocusMaster(
                                                              index,
                                                              "amountPay"
                                                            )
                                                          }
                                                          onBlur={(e) =>
                                                            handleBlurMaster(
                                                              index,
                                                              "amountPay",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            (mode === "U" || paymentStatus === "oneTime") &&
                                                            docRefType !== "4"
                                                          }
                                                          onInput={(e) => {
                                                            if (
                                                              /^0+/.test(
                                                                e.target.value
                                                              )
                                                            ) {
                                                              e.target.value =
                                                                e.target.value.replace(
                                                                  /^0+/,
                                                                  ""
                                                                );
                                                            }
                                                          }}
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            item.docRemark1 ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "docRemark1",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              .payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            item.docRemark2 ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "docRemark2",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              .payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>

                                            {/* Modal For DatePicker */}
                                            <div
                                              className={`modal fade ${showModalDatePicker
                                                ? "show"
                                                : ""
                                                }`}
                                              style={{
                                                display: showModalDatePicker
                                                  ? "block"
                                                  : "none",
                                              }}
                                              tabIndex="-1"
                                              role="dialog"
                                            >
                                              <div
                                                className="modal-dialog modal-dialog-centered modal-md"
                                                role="document"
                                              >
                                                <div className="modal-content">
                                                  <div
                                                    className="modal-header"
                                                    style={{
                                                      backgroundColor:
                                                        "#E13F57",
                                                    }}
                                                  >
                                                    <h5 className="modal-title text-white">
                                                      เลือกวันที่
                                                    </h5>
                                                    <button
                                                      type="button"
                                                      className="close"
                                                      onClick={
                                                        closeModalDatePicker
                                                      }
                                                      style={{ color: "white", fontSize: "26px" }}
                                                    >
                                                      <span>&times;</span>
                                                    </button>
                                                  </div>
                                                  <div
                                                    className="modal-body"
                                                    style={{
                                                      backgroundColor:
                                                        "#F5F7FD",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      label="เลือกวันที่"
                                                      name="datePay"
                                                      value={
                                                        formMasterList[
                                                          selectedDateIndex
                                                        ]?.datePay || moment()
                                                      }
                                                      onChange={(date) => {
                                                        handleChangeDateMasterList(
                                                          date,
                                                          "datePay",
                                                          selectedDateIndex
                                                        );
                                                      }}
                                                      disabled={false}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {paymentStatus !== "installment" && (
                                <div className="card mt-3">
                                  <div className="card-body">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                      <h5 className="mb-0">ช่องทางการชำระ</h5>
                                    </div>
                                    <div className="btn-group mt-3" role="group">
                                      <button type="button" className={`btn ${paymentType.transfer ? 'btn-danger' : 'btn-outline-secondary'}`} onClick={() => togglePaymentMethod("transfer")} disabled={!canEditPaymentChannel}>โอนเงิน</button>
                                      <button type="button" className={`btn ${paymentType.cash ? 'btn-danger' : 'btn-outline-secondary'}`} onClick={() => togglePaymentMethod("cash")} disabled={!canEditPaymentChannel}>เงินสด</button>
                                      <button type="button" className={`btn ${paymentType.cheque ? 'btn-danger' : 'btn-outline-secondary'}`} onClick={() => togglePaymentMethod("cheque")} disabled={!canEditPaymentChannel}>เช็ค</button>
                                    </div>
                                    {paymentType.transfer && (
                                      <div className="mt-3 p-3 border rounded" style={{ backgroundColor: "#f7f7f7" }}>
                                        <div className="row g-3">
                                          <div className="col-md-4">
                                            <label className="form-label">จำนวนเงิน (โอน)</label>
                                            <input type="text" className="form-control text-end input-spacing" value={paymentAmount.transfer || "0.00"} onFocus={() => handlePaymentAmountFocus("transfer")} onBlur={() => handlePaymentAmountBlur("transfer")} onChange={(e) => handlePaymentAmountChange("transfer", e.target.value)} disabled={!canEditPaymentChannel} />
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label">วันที่โอน</label>
                                            <DatePicker
                                              label=""
                                              name="payDatetime"
                                              value={payDatetime || ""}
                                              onChange={(val) => setPayDatetime(val)}
                                              disabled={!canEditPaymentChannel}
                                            />
                                          </div>
                                        </div>
                                        <div className="row g-2 mt-1">
                                          <div className="col-12">
                                            <div className="form-check mb-2">
                                              <input className="form-check-input" type="radio" name="bankInputMode" id="transferBankSelect" value="select" checked={bankInputMode === "select"} onChange={() => { if (!canEditPaymentChannel) return; setBankInputMode("select"); setBankMasterId(""); setPayToAccNo(""); setPayToAccName(""); setPayToBranch(""); }} disabled={!canEditPaymentChannel} />
                                              <label className="form-check-label" htmlFor="transferBankSelect">เลือกบัญชีธนาคาร</label>
                                            </div>
                                            <div className="form-check mb-2">
                                              <input className="form-check-input" type="radio" name="bankInputMode" id="transferBankManual" value="manual" checked={bankInputMode === "manual"} onChange={() => { if (!canEditPaymentChannel) return; setBankInputMode("manual"); setBankId(""); }} disabled={!canEditPaymentChannel} />
                                              <label className="form-check-label" htmlFor="transferBankManual">ระบุเอง</label>
                                            </div>
                                          </div>
                                        </div>
                                        {bankInputMode === "select" ? (
                                          <div className="row g-2 mt-1">
                                            <div className="col-md-6">
                                              <label className="form-label">บัญชีธนาคาร</label>
                                              <select className="form-select" value={bankId} onChange={(e) => setBankId(e.target.value)} disabled={!canEditPaymentChannel}>
                                                <option value="">-- เลือกบัญชีธนาคาร --</option>
                                                {bankDataList.map((bank) => (
                                                  <option key={bank.Bank_Id} value={bank.Bank_Id}>
                                                    {bank.Bank_Account} - {bank.Bank_Name_TH}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>
                                          </div>
                                        ) : (
                                          <>
                                            <div className="row g-2 mt-1">
                                              <div className="col-md-4">
                                                <label className="form-label">ธนาคาร</label>
                                                <select className="form-select" value={bankMasterId} onChange={(e) => setBankMasterId(e.target.value)} disabled={!canEditPaymentChannel}>
                                                  <option value="">-- เลือกธนาคาร --</option>
                                                  {masterBankDataList.map((bank) => (
                                                    <option key={bank.Bank_Master_Id} value={bank.Bank_Master_Id}>
                                                      {bank.B_Name_TH}
                                                    </option>
                                                  ))}
                                                </select>
                                              </div>
                                              <div className="col-md-4">
                                                <label className="form-label">เลขที่บัญชี</label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  value={payToAccNo}
                                                  onChange={(e) => handleAccNoChange(e.target.value)}
                                                  onBlur={handleAccNoBlur}
                                                  disabled={!canEditPaymentChannel}
                                                  placeholder="xxx-xxx-xxxx"
                                                  inputMode="numeric"
                                                  maxLength={13}
                                                  pattern="\\d{3}-\\d{3}-\\d{4}"
                                                  title="รูปแบบเลขที่บัญชี: xxx-xxx-xxxx"
                                                />
                                              </div>
                                              <div className="col-md-4">
                                                <label className="form-label">ชื่อบัญชี</label>
                                                <input type="text" className="form-control" value={payToAccName} onChange={(e) => setPayToAccName(e.target.value)} disabled={!canEditPaymentChannel} />
                                              </div>
                                            </div>
                                            <div className="row g-2 mt-1">
                                              <div className="col-md-4">
                                                <label className="form-label">สาขา</label>
                                                <input type="text" className="form-control" value={payToBranch} onChange={(e) => setPayToBranch(e.target.value)} disabled={!canEditPaymentChannel} />
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    )}
                                    {paymentType.cash && (
                                      <div className="mt-3 p-3 border rounded" style={{ backgroundColor: "#f7f7f7" }}>
                                        <div className="row g-3 ">
                                          <div className="col-md-4">
                                            <label className="form-label">จำนวนเงิน (เงินสด)</label>
                                            <input type="text" className="form-control text-end input-spacing" value={paymentAmount.cash || "0.00"} onFocus={() => handlePaymentAmountFocus("cash")} onBlur={() => handlePaymentAmountBlur("cash")} onChange={(e) => handlePaymentAmountChange("cash", e.target.value)} disabled={!canEditPaymentChannel} />
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {paymentType.cheque && (
                                      <div className="mt-3 p-3 border rounded" style={{ backgroundColor: "#f7f7f7" }}>
                                        <div className="row g-3">
                                          <div className="col-md-4">
                                            <label className="form-label">จำนวนเงิน (เช็ค)</label>
                                            <input type="text" className="form-control text-end input-spacing" value={paymentAmount.cheque || "0.00"} onFocus={() => handlePaymentAmountFocus("cheque")} onBlur={() => handlePaymentAmountBlur("cheque")} onChange={(e) => handlePaymentAmountChange("cheque", e.target.value)} disabled={!canEditPaymentChannel} />
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label">เลขที่เช็ค</label>
                                            <input type="text" className="form-control" value={chequeNo} onChange={(e) => setChequeNo(e.target.value)} disabled={!canEditPaymentChannel} />
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label">ชื่อผู้ออกเช็ค</label>
                                            <input type="text" className="form-control" value={chequeName} onChange={(e) => setChequeName(e.target.value)} disabled={!canEditPaymentChannel} />
                                          </div>
                                        </div>
                                        <div className="row g-2 mt-1">
                                          <div className="col-md-4">
                                            <label className="form-label">ธนาคาร / สาขา</label>
                                            <input type="text" className="form-control" value={chequeBranch} onChange={(e) => setChequeBranch(e.target.value)} disabled={!canEditPaymentChannel} />
                                          </div>
                                          <div className="col-md-4">
                                            <label className="form-label">วันที่เช็ค</label>
                                            <DatePicker
                                              label=""
                                              name="chequeDate"
                                              value={chequeDate || ""}
                                              onChange={(val) => setChequeDate(val)}
                                              disabled={!canEditPaymentChannel}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {(paymentType.cash || paymentType.transfer || paymentType.cheque) && (
                                      <div className="row mt-2">
                                        <div className="col-12">
                                          <small className={`${Math.abs((getSelectedPaymentTotal() || 0) - (parseCurrency(FinalTotal || 0) || 0)) < 0.01 ? "text-muted" : "text-danger"}`}>
                                            รวมช่องทางการชำระ {formatCurrency(getSelectedPaymentTotal() || 0)} บาท
                                            {Math.abs((getSelectedPaymentTotal() || 0) - (parseCurrency(FinalTotal || 0) || 0)) >= 0.01 && ` (ยอดสุทธิ ${formatCurrency(parseCurrency(FinalTotal || 0) || 0)} บาท)`}
                                          </small>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title">รายละเอียดสินค้า</h4>
                        <button
                          type="button"
                          className="btn text-white mx-3"
                          onClick={handleItemShow}
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "10px",
                            fontSize: "15px",
                          }}
                          hidden={
                            docRefType === "1" || docRefType === "3" || docRefType === "4"
                              ? true
                              : false
                          }
                          disabled={formMasterList[0].payStatus !== 1}
                        >
                          <i className="fa fa-plus"></i> เพิ่มรายการ
                        </button>
                      </div>
                      <ItemModal
                        formDetailList={formDetailList}
                        showItemModal={showItemModal}
                        handleItemClose={handleItemClose}
                        itemDataList={itemDataList}
                        setItemDataList={setItemDataList}
                        onRowSelectItem={onRowSelectItem}
                      />
                      <div className="card-body">
                        <div
                          className="table-responsive"
                          style={{ maxHeight: "500px", overflowY: "auto" }}
                        >
                          <table
                            id="basic-datatables"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "2%" }}
                                >
                                  #
                                </th>
                                {(docRefType === "1" || docRefType === "4") && (
                                  <th
                                    className="text-center"
                                    style={{ width: "8%" }}
                                  >
                                    เลขที่เอกสาร {docRefType === "1" ? "(REC)" : "(PO)"}
                                  </th>
                                )}
                                <th
                                  className="text-center"
                                  style={{
                                    width: docRefType !== "1" ? "12%" : "10%",
                                  }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{
                                    width: docRefType === "1" || docRefType === "4" ? "16%" : "18%",
                                  }}
                                >
                                  ชื่อสินค้า
                                </th>

                                {docRefType === "2" && (
                                  <th
                                    className="text-center"
                                    style={{
                                      width: "18%",
                                    }}
                                  >
                                    หมายเหตุ
                                  </th>
                                )}

                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  จำนวน
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "6%" }}
                                >
                                  หน่วย
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  ราคาต่อหน่วย
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  ส่วนลด
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "5%" }}
                                >
                                  %
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  จำนวนเงินรวม
                                </th>
                                {docRefType === "2" && (
                                  <th
                                    className="text-center"
                                    style={{ width: "3%" }}
                                  >
                                    ลบ
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {formDetailList
                                .sort((a, b) => a.line - b.line)
                                .map((item, index) => (
                                  <tr key={item.itemId || index + 1}>
                                    {/* # */}
                                    <td className="text-center">{index + 1}</td>

                                    {/* # RecNo */}
                                    <td
                                      hidden={docRefType === "1" ? false : true}
                                      className="text-center"
                                    >
                                      <span>{item.recNo || ""}</span>
                                    </td>

                                    {/* # PoNo */}
                                    <td
                                      hidden={docRefType === "4" ? false : true}
                                      className="text-center"
                                    >
                                      <span>{item.docNo || ""}</span>
                                    </td>

                                    {/* รหัสสินค้า */}
                                    <td className="text-center">
                                      <span>{item.itemCode || ""}</span>
                                    </td>

                                    {/* ชื่อสินค้า */}
                                    <td className="text-left">
                                      <span>{item.itemName || ""}</span>
                                    </td>

                                    {/* หมายเหตุ */}
                                    {docRefType === "2" && (
                                      <td className="text-left">
                                        <input
                                          type="text"
                                          className="form-control text-left"
                                          value={item.itemDesc || ""}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDesc",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            formMasterList[0].payStatus !== 1
                                          }
                                        />
                                      </td>
                                    )}

                                    {/* จำนวน */}
                                    <td className="text-center">
                                      {docRefType === "1" || docRefType === "4" ? (
                                        <span>{item.itemQty || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-center"
                                          value={item.itemQty || 0}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemQty",
                                              e.target.value
                                            )
                                          }
                                          onFocus={(e) =>
                                            handleFocusDetail(index, "itemQty")
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemQty",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" || docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* หน่วย */}
                                    <td className="text-center">
                                      <span>{item.itemUnit || ""}</span>
                                    </td>

                                    {/* ราคาต่อหน่วย */}
                                    <td className="text-end">
                                      {docRefType === "1" ||
                                        docRefType === "3" || docRefType === "4" ? (
                                        <span>{item.itemPriceUnit || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-end"
                                          value={item.itemPriceUnit || ""}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemPriceUnit",
                                              e.target.value
                                            )
                                          }
                                          onFocus={() =>
                                            handleFocusDetail(
                                              index,
                                              "itemPriceUnit"
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemPriceUnit",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* ส่วนลด */}
                                    <td className="text-end">
                                      {docRefType === "1" ||
                                        docRefType === "3"
                                        || docRefType === "4" ? (
                                        <span>{item.itemDiscount || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-end"
                                          value={item.itemDiscount || 0}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDiscount",
                                              e.target.value
                                            )
                                          }
                                          onFocus={() =>
                                            handleFocusDetail(
                                              index,
                                              "itemDiscount"
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemDiscount",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* % */}
                                    <td className="text-center">
                                      {docRefType === "1" ||
                                        docRefType === "3" || docRefType === "4" ? (
                                        <span>
                                          {item.itemDisType === "1"
                                            ? "฿"
                                            : item.itemDisType === "2"
                                              ? "%"
                                              : ""}
                                        </span>
                                      ) : (
                                        <select
                                          className="form-select"
                                          value={item.itemDisType || ""}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDisType",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                        >
                                          <option value="1">฿</option>
                                          <option value="2">%</option>
                                        </select>
                                      )}
                                    </td>

                                    {/* จำนวนเงินรวม */}
                                    <td className="text-end">
                                      <span>
                                        {formatCurrency(item.itemTotal || 0)}
                                      </span>
                                    </td>

                                    {docRefType === "2" && (
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          onClick={() => handleRemoveRow(index)}
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                        >
                                          ลบ
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <br />
      <FormAction
        onSubmit={isReadOnly ? undefined : handleSubmit}
        onUpdate={isReadOnly ? undefined : handleUpdate}
        onCancel={isReadOnly ? undefined : handleCancel}
        onApprove={showApprovalButtons ? handleApproveAction : undefined}
        onReject={showApprovalButtons ? handleRejectAction : undefined}
        mode={mode}
        setMode={setMode}
        disabled={isReadOnly || formMasterList[0].payStatus !== 1}
        showCancelButton={!isReadOnly}
        showApproveButton={showApprovalButtons}
        showRejectButton={showApprovalButtons}
        approveLabel="อนุมัติ"
        rejectLabel="ไม่อนุมัติ"
        approveDisabled={!showApprovalButtons || !isPendingApproval || approvalBusy}
        rejectDisabled={!showApprovalButtons || !isPendingApproval || approvalBusy}
        footer={true}
      />
    </>
  );
}

export default Form;
